/* eslint-disable prettier */
/**
 * Russian resource file
 */
import {
    roles,
    daySelection,
    GARoleTypeId,
    toggleCCPEntityDetail,
    readinessReportCategories,
    archiveReportQualifiedTypeId,
    natureOfEngagements,
    dashboardTabId,
    dashboardViews as dashboardViewsConstants,
    accountDesignations,
    groupRiskStatus,
    riskTypeIds
} from '../util/uiconstants';

export const labels = {
    clearFilter: "全てクリア",
    canvasOversight: "Canvas Oversight",
    oversight: "Oversight",
    canvasLabel: "Canvas",
    myProjects: "マイプロジェクト",
    otherProjects: "他のプロジェクト",
    priorProjects: "過去のプロジェクト",
    completedProjects: "完了済のプロジェクト",
    completedLabel: "完了",
    createProject: "プロジェクトの作成",
    rollForward: "ロールフォワード",
    rollForwardLabel: "ロールフォワード",
    rollForwardTitle: "プロジェクトをロールフォワードする",
    project: "プロジェクト",
    openProject: "プロジェクトを開く",
    manageUsers: "ユーザーの管理",
    rollForwardInstructionalText: "プロジェクトをロールフォワードしてよろしいですか？<br> 新しいプロジェクトを作成する時に、完了したプロジェクトをテンプレートとして使用できるようになります。以下の情報がロールフォワードされます：プロジェクト名、組織図、グループ及びグループ管理者。",
    isClientUserError: "アクティブなプロジェクトはありません。プロジェクトにインバイトされているEYチームメンバーと協議してください。",
    activeProjects: "アクティブなプロジェクト",
    myActiveProjects: "アクティブなマイプロジェクト",
    otherActiveProjects: "アクティブな他のプロジェクト",
    myCompletedProjects: "完了済のマイプロジェクト",
    myActiveProjectsPlaceholder: "ここにリストされているEY Canvas Oversightプロジェクトにアクセスできます。プロジェクト名を選択して開くか、カウントをクリックすると詳細を表示できます。",
    deleteProject: "プロジェクトの削除",
    deleteProjectModalText: "このプロジェクトを削除してよろしいですか？<br>プロジェクトはランディングページから削除され、チームメンバーはアクセスできなくなります。",
    createButton: "プロジェクトの作成",
    search: "検索",
    searchEngagement: "エンゲージメントの検索",
    searchEngagements: "エンゲージメントの検索",
    searchEntitiesAndEngagements: "エンティティ及びエンゲージメントを検索",
    searchClientList: "クライアント名の検索",
    noDataFound: "表示できるデータはありません",
    expand: "展開",
    collapse: "折りたたむ",
    more: "増やす",
    options: "オプション",
    editProject: "プロジェクトの編集",
    manageTeam: "チーム管理",
    markAsCompleted: "完了としてマーク",
    connectedTo: "次と接続済：",
    connectedClients: "接続されたクライアント",
	connectedToClients: (count) => `${count} ${count == 1 ? 'クライアント' : 'クライアント'}`,
	connectedToEngagements: (count) => `エンゲージメント: ${count == 0 ? 'なし' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? 'エンゲージメント' : 'エンゲージメント'}`,
	connectToEngagements: (count) => `接続 ${count} ${count == 1 ? 'エンゲージメント' : 'エンゲージメント'}`,
	connectedToAccessGroups: (count) => `次と接続済 ${count} ${count == 1 ? 'グループ' : 'グループ'}`,
	connectToAccessGroups: (count) => `接続 ${count} ${count == 1 ? 'グループ' : 'グループ'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'エンティティ' : 'エンティティ'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'ビュー' : 'ビュー'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'ドメイン' : 'ドメイン'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'ビュー' : 'ビュー'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'ドメイン' : 'ドメイン'}`,
    engagement: "エンゲージメント",
    engagementNameLabel: "エンゲージメント名",
    engagementPartnerLabel: "業務執行社員",
    partnerLabel: "パートナー",
    notInvited: "インバイトされていない",
    clientNameLabel: "クライアント名",
    client: "クライアント",
    codeLabel: "コード",
    idLabel: "ID",
    engagements: "エンゲージメント",
    engagementsLabel: "エンゲージメント",
    noResultsFound: "結果が見つかりません。",
    submit: "提出",
    saveAndContinue: "保存して続行",
    savecontinue: "保存して続行",
    saveDraft: "ドラフトとして保存",
    closeLabel: "閉じる",
    step1: "ステップ 1",
    step2: "ステップ 2",
    step3: "ステップ 3",
    step4: "ステップ 4",
    step5: "ステップ 5",
    adminsNoneLabel: "なし",
    domainsAllLabel: "すべて",
    adminsHeaderLabel: "管理者:",
    domainsHeaderLabel: "ドメイン:",
    moreCountLabel: '+ {0}',
    selectClient: "クライアントを選択",
    createOrgChart: "組織図を作成",
    connnectToCanvas: "EY Canvasに接続する",
    viewSummary: "サマリービュー",
    viewLabel: "表示",
    cancelLabel: "キャンセル",
    required: "必須",
    filter: "フィルター",
    filtersWarningMessage: "フィルターの適用上限数を超えています。一度に25までのフィルターが適用できます。",
    back: "戻る",
    save: "保存",
    saveClose: "保存して閉じる",
    continue: "続行",
    finish: "完了",
    saveChanges: "変更を保存",
    projectName: "プロジェクト名",
    projectOwners: "プロジェクトオーナー",
    addAnotherProjectOwner: "別のプロジェクトオーナーを追加する",
    duplicateOwnerAdded: "ユーザーをコピーする",
    step1InstructionHeader: "プロジェクト名を入力してプロジェクトオーナーを追加し、以下のリストから1つ以上のクライアントを選択して始めて下さい。",
	step1SubInstructionPart1: `RA RU You must have access to the client's GIS, GFIS, or Mercury codes or to an EY Canvas engagement to see the client's name below. The clients that you select on this step will determine which EY Canvas engagements are available to connect to your project. To learn more on how to use EY Canvas Oversight, check out our {link}`,
    step2InstructionHeader: "プロジェクトの組織図を作成",
    step2SubInstructionPart1: "組織図は、クライアントがビジネスを管理する方法を反映している必要があります。これは、プロジェクトに接続するEY Canvasエンゲージメントのデータを要約するとともに、内部及び外部のチームメンバーのアクセス管理に使用されます。",
    here: "こちら",
    zoomIn: "拡大",
    zoomOut: "縮小",
    expandAll: "すべてを展開",
    collapseAll: "すべてを折りたたむ",
    addLabel: "追加",
    editLabel: "編集",
    removeLabel: "削除",
    noRowsTemplateStringPart1: "クライアントにアクセスできません。以下をクリック：",
    noRowsTemplateStringPart2: "アクセスする方法の詳細については。",
    noRowSelected: "続行するには、少なくとも1つのクライアントを選択してください。",
    firstName: "名",
    lastName: "姓",
    displayLanguage: "言語表示",
    numberFormat: "数値フォーマット",
    dateFormat: "日付の形式",
    timezone: "タイムゾーン",
    theme: "テーマ",
    chooseDisplayTheme: "デフォルトの表示テーマを選択",
    light: "ライト",
    dark: "ダーク",
    usersettings: "ユーザー設定",
    userOptions: "ユーザーオプション",
    clearHoverText: "クリア",
    noFiltersAvailable: "利用可能なフィルターがありません",
    dashboard: "ダッシュボード",
    milestones: "マイルストーン",
    activityFeed: "アクティビティフィード",
    keyEvents: "キーイベント",
    keyEventCompletion: "キーイベントの完了",
    canvasClientPortal: "Canvas Client Portal",
    canvasClientPortalEy: "EY Canvas Client Portal",
    groupAudit: "グループ監査",
    projectManagement: "プロジェクト管理",
    reporting: "レポーティング",
    insights: "インサイト",
    groupRiskAssessment: "グループリスク評価",
    internal: "内部",
    external: "外部",
    members: "メンバー",
    show: "表示",
    showDetails: "詳細を表示",
    showMore: "RA RU Show more",
    showLess: "RA RU Show less",
    clientName: "クライアント名",
    clientsLabel: "クライアント",
    clientLabel: "クライアント",
    source: "ソース",
    code: "コード",
    accessDelegatedBy: "アクセス権限委譲者",
    returnToPreviousStep: "前のステップに戻る",
    backButtonWarning: "前のステップに戻って変更すると、このステップの進行に影響が生じる可能性があります。<br><b>続行</b>を選択して前のステップに戻るか、<b>キャンセル</b>を選択してこのステップに留まります。",
    step1SubInstructionPart3: "このステップでどのクライアントを選択するかによって、プロジェクトに接続して利用可能なEY Canvasエンゲージメントが決定されます。",
    step3InstructionHeader: "1つ以上のEY Canvasエンゲージメントを選択し、それらを組織図にドラッグアンドドロップしてください",
    step3InstructionPara: "EY Canvasエンゲージメントと組織図上のエンティティとの関係により、EY Canvasデータがプロジェクトのダッシュボードにどのように要約されるかが決定します。",
    availableLabel: "利用可能",
    connectedLabel: "接続済",
    milestoneSummaryView: "マイルストーン - サマリービュー",
    taskCompletionByMilestone: "マイルストーンによるタスクの完了",
    basedOnTaskCompletition: "タスクの完了に基づく",
    scopeAndStrategy: "スコープ及び戦略",
    execution: "実施",
    conclusion: "総括",
    step3ListDefaultMessage: "ステップ1で選択したクライアントは利用可能なエンゲージメントではありません。続行するには、ステップ1に戻り、別のクライアントを選択してください。",
    addNewEngagementLabel: "新規エンゲージメントの追加",
    selectedLabel: "選択",
    moreText: "さらに",
    connectLabel: "接続",
    connectEngagements: "接続済のエンゲージメント",
    connectToAnEngagement: "エンゲージメントを接続して開始してください",
    connectToAnAccessGroup: "グループが接続されていません。",
    tasks: "タスク",
    organizationalChartHeading: "エンティティ",
    groupAdministratorsLabel: "グループ管理者",
    step4InstructionHeader: "プロジェクトのグループを作成し、それらを組織図の2つ以上のエンティティに接続してください。",
    step4ImportantNote: "重要な注意事項: グループのメンバーは、グループを接続する組織図のエンティティとそれらのエンティティの子のEY Canvasエンゲージメントデータを表示可能です。グループを組織図の親エンティティに接続すると、グループは親エンティティとその全ての子のEY Canvasエンゲージメントデータを表示可能になります。",
    addAGroup: "グループの追加",
    addGroup: "グループの追加",
    searchGroup: "グループ検索",
    addNewGroupHeader: "ここに新規グループを作成します。",
    editNewGroupHeader: "ここで既存のグループを編集する。",
    addNewGroupInstruction: "プロジェクトの作成後、内部及び外部のチームメンバーをこのグループにインバイト可能です。このグループにメンバーをインバイト可能なグループ管理者の追加は任意です。",
    groupName: "グループ名",
    groupAdministrators: "グループ管理 (任意)",
    groupAdministratorsSubHeading: "グループ管理者を追加してください。グループ管理者は、プロジェクトの作成後にメンバーをプロジェクトにインバイトできます。インバイトされたメンバーはこのグループのビューとドメインを編集することはできません。",
    clearAllValues: "クリア",
    createGroupDashboardViews: "ダッシュボード画面",
    dashboardViewsSubHeading: "少なくとも1つのビューを選択してください。これにより、メンバーがプロジェクトに対するダッシュボード閲覧時に確認可能なデータが決定されます。",
    duplicateDomain: "ドメインの複製",
    allMilestones: "全てのマイルストーン",
    someMilestonesSelected: 'RA RU {0} milestones selected',
    noGroupsAdded: "このプロジェクトにはドメインが追加されていません。",
    step5InstructionHeader: "EY CanvasのOversightプロジェクトをレビューしてください。",
    step5SubInstruction: "変更が必要な場合は、編集の鉛筆アイコンを選択すると前のステップに戻ります。<b>前のステップを変更すると、後のステップの進行に影響する可能性があります。</b>",
    associationNotRequired: "関連付けは必要ありません",
    accessGroupAlreadyAddedToParent: "選択した1つ以上のグループを既に親エンティティに関連付けています。アクセスグループが親エンティティに接続されている場合、そのメンバーは親エンティティとその全ての子のEY Canvasエンゲージメントデータを表示できます。従って、関連付けは必須ではありません。",
    deleteGroupInstructionalText: "このグループを削除してよろしいですか？ <br> 削除すると元に戻せません。グループのメンバーはプロジェクトにアクセスできなくなります。",
    deleteGroup: "グループを削除",
    removeMember: "メンバーの削除",
    removeMemberTitle: "このチームメンバーを削除してよろしいですか？このメンバーが複数グループに所属する場合、ここに掲げられた全てのグループから削除され、このプロジェクトにアクセスできなくなる場合があります。単一グループから削除する場合、代わりに<b>編集</b>オプションを選択してください。",
    teamMember: "チームメンバー",
    clientNameLbl: "クライアント",
    help: "ヘルプ",

    //Org char left rail
    filters: "フィルター",
    countEngagementSelected: " {1} エンゲージメントの{0}が選択されました",
    of: "{num} 個の",
    entityName: "エンティティ名",
    enterEntityName: "ここに名前を入力してください",
    projectOwner: "プロジェクトオーナー",
    role: "ロール",
    domains: "ドメイン（任意）",
    domainSubHeading: "外部のチームメンバをこのグループにインバイトする場合、少なくとも1つのドメインを追加してください。ドメインはメールアドレスの@記号の後の文字を指します。外部のチームメンバーを追加するには、このグループの有効なドメインが必要です。",
    addAdministrator: "グループ管理者の追加",
    addNewDomain: "新規ドメインの追加",
    addExistingDomain: "既存ドメインの追加",
    placeholderStep3NoEngagementMessage: "ステップ1で選択したクライアントは利用可能なエンゲージメントではありません。続行するには、ステップ1に戻り、別のクライアントを選択してください。",
    placeholderStep3NoConnectedEngagementMessage: "接続されたエンゲージメントがありません。",
    placeholderStep3AllEngagementsConnected: "全ての利用可能なエンゲージメントはプロジェクトに接続しています。",
    placeholderStep4NoConnectedGroupMessage: "接続されたグループはありません。",
    domainName: "ドメイン名",
    engagementLabel: "エンゲージメント",
    start: "開始",
    end: "終了",
    suggestedEnd: "提案された終了",
    status: "ステータス",
    thereIsNoDataToDisplay: "表示するデータがありません。",
    selectadditionalEntitiesToContinue: "続行するには、追加のエンティティを選択してください。",
    comingSoonToDisplay: "構成単位のステータスはまもなく利用可能になります。",
    checkForUpdatesToDisplay: "今後数週間以内に更新を確認して下さい。",
    userSearchPlaceholder: "名前またはメールアドレスを入力し、Enterキーを押して結果を確認してください",
    userSearchPlaceholderForExternal: "メールアドレスを入力し、Enterキーを押して結果を確認してください",
    partnerInChargeInvitedToTheEngagement: "エンゲージメントにインバイトされた筆頭業務執行社員",
    partnerInChargeSignedOffOnCraSummary: "CRAサマリー上の筆頭業務執行社員のサインオフ",
    eqrSignedOffOnCraSummary: "CRAサマリー上のEQRのサインオフ",
    partnerInChargeSignedOffOnAuditPlan: "監査計画上の筆頭業務執行社員のサインオフ",
    picInvited: "PICインバイト",
    picSignOffCRA: "CRAへのPICサインオフ",
    picSignOffAuditPlan: "監査計画へのPICサインオフ",
    eqrSingOffCRA: "CRAへのEQR(IRP)サインオフ",
    overdue: "期限超過",
    outOf: "／",
    edit: "編集",
    remove: "削除 ",
    add: "追加",
    admin: "管理者",
    views: "表示",
    domainLabel: "ドメイン",
    domainslabel: "ドメイン",
    viewLabelText: "表示",
    viewsLabelText: "表示",
    administrators: "管理者",
    none: "なし",
    organizationChart: "組織図",
    invalidDomainName: "無効なドメイン名",
    lastRefreshed: 'RU Last refreshed',
	lastRefreshedActivityFeed: 'RU Activity feed data last refreshed',
	lastRefreshedReconciliation: 'RU Reconciliation data last refreshed',
    quickFilter: "クイックフィルター",
    notApplied: "未適用",
    quickFilterInput: "クイックフィルター名",
    quickFilterSubHeaderText: "完了すると、クイックフィルターを適用し、個別にエンティティを選択しなくともデータを閲覧したいエンティティを絞り込むことができます。",
    createFilterTrigger: "新しいフィルターを作成",
    createFilterTitle: "新しいクイックフィルターを作成",
    createFilterButton: "クイックフィルターを作成",
    createFilterHeaderText: "組織図から一つ以上のエンティティを選択すると、クイックフィルターを作成できます。",
    createFilterSubHeaderText: "完了すると、クイックフィルターを適用し、個別にエンティティを選択しなくともデータを閲覧したいエンティティを絞り込むことができます。",
    editFilterTitle: "クイックフィルターを編集",
    editFilterHeaderText: "クイックフィルターを編集または削除",
    editFilterIconTitleTip: "編集",
    oneRequired: "一つ以上選択してください。",
    noFiltersCreatedTitle: "まだクイックフィルターが作成されていません。",
    noFiltersCreatedSubTitle: "開始するにはクイックフィルターを作成してください。",
    clear: "クリア",
    completionRange: "完了範囲",
    engagementCount: "エンゲージメント総数",
    clickOnAVisualBelowToFilterTheEngagementList: "以下でエンゲージメントリストをフィルタリングします。",
    organizationalChartTooltip: "組織図 を選択して、EY Canvas Oversight プロジェクトからエンティティを編集または削除します。",
    organizationalChart: "組織図",

    //Task status chart labels
    open: "オープン",
    inProgress: "進行中",
    inReview: "レビュー中",
    completeUpperCase: "完了",
    taskStatusOverdue: "期限超過",
    noDataForSelections: "選択可能なデータがありません。",
    selectOneOrMoreMilestones: "続行するには、1つ以上の異なるマイルストーンを選択してください。",
    milestoneDetailTitle: "マイルストーン - 詳細",
    taskStatusByMilestone: "マイルストーンによるタスクのステータス",
    milestoneDetailSubtitle: "タスクのステータスに基づく",
    basedOnAllTasksForTheSelectedMilestone: "選択したマイルストーンの全てのタスクに基づく",
    totalTasks: "総タスク",
    noneSelected: "選択なし",
    nameOrEmail: "名前またはメール",
    remove: "削除 ",
    milestonesTooltipText: "マイルストーンによる監査の進捗状況",
    canvasClientPortalTooltipText: "期限間近、期限超過、差戻済のアイテムを含むリクエストステータス",
    groudAuditTooltipText: "差戻済及び期限超過のアイテムを含むプライマリーと構成単位のチームステータス",
    projectManagementTooltipText: "期限超過のアイテムを含む、レビューノート及び割当てのステータス。このビューはクライアントからは見えません。",
    insightsTootipText: "プライマリーチームと構成単位チーム間のリスク、実証手続、統制戦略、及び発見事項の比較。この表示はクライアントからは見えません。",
    reportTootipText: "準備、変更、及びタスク完了ステータスを国別に報告",
    taskStatusComplete: "タスクステータス - 完了",
    taskStatusInreview: "タスクステータス - レビュー中",
    taskStatusInprogress: "タスクステータス - 進行中",
    taskStatusOpen: "タスクステータス - オープン",

    //Review Notes chart labels
    reviewNotesByStatusTitle: "全てのレビューノート",
    byStatus: "ステータス別",
    totalNotes: "全ノート",
    totalNotesLabel: "全ノート",
    openNotes: "オープンノート",
    byPriority: "優先順位別",
    cleared: "クリア済",
    closed: "クローズ済",
    low: "低",
    medium: "中",
    high: "高",
    critical: "重要",
    notesTableTooltipContent: "オープンステータスのノートに基づく",

    // Group audit
    groupAuditTotalForms: "フォーム合計数",
    groupAuditNotSent: "送信前",
    groupAuditUnlinked: "リンク解除済",
    totalTasksCapitalized: "タスク合計数",
    primary: "プライマリー",
    component: "構成単位",

    //Bar chart
    are: "です",
    complete: "完了",
    noMilestoneDataForSelection: "この監査フェーズを表示するマイルストーンデータがありません。",
    selectDifferentAuditPhase: "別の監査フェーズを選択するか、追加のエンティティを選択して続行します。",

    //Delegate
    delegateInstruction: "他のチームメンバーにアクセスを委任して、他のチームメンバーがあなたに代わってプロジェクトを作成できるようにします。開始するには、チームメンバーの名前またはメールアドレスを入力します。代理人は、あなたのクライアントすべてにアクセス可能です。",

    delegateAccess: "権限委譲の管理",
    addAnother: "RA RU Добавить делегатов",
    hideMyDelegate: "委任を隠す",
    showMyDelegate: "委任を表示する",
    noRecord: "結果が見つかりません",
    duplicateUser: "既に追加された委任",
    duplicateUserMessage: "ユーザーは既に追加されています",
    addDelegates: "権限委譲の追加",
    delegateTo: "権限委譲先",
    delegateFrom: "権限委譲元",
    delegateToMsg: "チームメンバーにアクセス権限を委譲していません。",
    delegateFromMsg: "あなたにアクセス権限を委譲したメンバーはいません。",

    // Project dashboard left rail
    searchFilterPlaceholder: "フィルターの検索",
    searchEntitiesPlaceholder: "エンティティの検索",
    outOfEngagements: "<b>{0}</b> 以外の<b>{1}</b> エンゲージメント",
    engagementCompletedBasedOnTaskCompletion: "<b>{0}</b> エンゲージメントです<b>{1}</b> タスクの完了に基づいて完了した",
    engagementsCompletedBasedOnTaskCompletion: "<b> {0} {0}エンゲージメントは、タスクの完了に基づいて<b> {1} </b>完了しています",
    engagementCompletedBasedOnTaskCompletionReporting: "<b> {0} {0}エンゲージメントは、タスクの<b> {1} </b>を完了しました",
    engagementsCompletedBasedOnTaskCompletionReporting: "<b> {0} {0}エンゲージメントは、タスクの<b> {1} </b>を完了しました",
    engagementCompletedBasedOnTaskCompletionMilestone: "<b> {0} {0}エンゲージメントは、このマイルストーンのタスクの<b> {1} </b>を完了しました",
    engagementsCompletedBasedOnTaskCompletionMilestone: "<b> {0} {0}エンゲージメントは、このマイルストーンのタスクの<b> {1} </b>を完了しました",
    reportReleaseDate: "報告書日",
    partnerInvited: "インバイトされたパートナー",
    picSignoffOnCra: "CRA上のPICのサインオフ",
    eqrSignoffOnCra: "CRA上のEQRのサインオフ",
    picSignoffOnAuditPlan: "監査計画上のPICのサインオフ",
    overdueLabel: "期限超過",

    //Team members
    teamMembersTitle: "チームメンバー",
    membersTitle: "メンバー",
    eyContactsTitle: "EYの連絡先",
    allMembersLabel: "全てのメンバー",
    internalMembersLabel: "内部メンバー",
    externalMembersLabel: "外部メンバー",
    groupsTitle: "マイグループ",
    projectOwnersTitle: "プロジェクトオーナー",
    projectOwnersLabel: "プロジェクトオーナー",
    projectOwnerLabel: "プロジェクトオーナー",

    //CCP
    summary: "サマリー",
    requestsByStatus: "ステータス別リクエスト",
    totalRequests: "リクエスト合計",
    totalRequestsTitle: "リクエスト合計数",
    receivedByEy: "EY受領済",
    acceptedByEy: "EY承諾済",
    outstandingByEy: "未対応",
    returned: "差戻済",
    receivedByEyOnTime: "EYで期日内受領済",
    averageDaysOverdue: "平均期限超過日数",
    outOfReceivedAndAccepted: "<b>{0}</b> ／ <b>{1}</b> 受領済及び承諾済リクエスト",
    outOfStandingRequests: "<b>{0}</b> ／ <b>{1}</b> 未対応リクエスト",
    outOfAverageDaysOverdue: "<b>{0}</b> ／ <b>{1}</b> 未対応リクエスト",
    draftRequests: "{0} ドラフトリクエスト",
    noResultMessageHeader: "表示するデータがありません。続行するには、追加するエンティティを選択してください。",
    noResultMessageSubHeader: '',
    members: "メンバー",
    memberLabel: "メンバー",
    adminLabel: "管理者",
    projectOwnerLabel: "プロジェクトオーナー",
    viewsLabel: "表示",
    metrics: "指標",
    yes: "はい",
    no: "いいえ",
    emptyMessageAvailableGroup: "グループはまだ作成されていません。<br>  <b>グループの追加</b>を選択すると 開始できます。",
    thereIsNoDataToDisplayForThisEntity: "このエンティティに表示するデータはありません。",
    typeLabel: "タイプ",
    groupsLabel: "グループ",
    group: "グループ",
    entitiesLabels: "エンティティ",
    entityLabel: "エンティティ",
    nameLabel: "名前",
    searchTeamMembers: "チームメンバーの検索",
    notSelectedLabel: "未選択",
    entitiesLabel: "エンティティ",
    noDataAvailableLabel: "利用可能なデータがありません。",
    delete: "削除",
    deleted: "削除済",
    addAMember: "メンバーの追加",
    addMemberHeaderText: "プロジェクトの1つ以上のグループに新しいメンバーを追加",
    teamMemberInformation: "チームメンバー情報",
    teamMemberNote: "選択したグループに追加する内部または外部のチームメンバーの名前又はEメールアドレスを入力し、Enterキーを押して結果を確認してください。",
    selectGroupNote: "少なくとも1グループ選択してください。グループメンバーは、グループが接続されている全ての組織図のエンティティとそれらのエンティティの子のEY Canvasエンゲージメントデータを表示可能です。",
    inviteAndClose: "インバイト & 閉じる",
    inviteAndAddAnother: "インバイト & 他の追加",
    contacts: "連絡先",
    email: "Eメール",
    emailAll: "全てにEメール",
    contactTeam: "チームの連絡先",
    emptyMessage: "このエンゲージメントに利用可能な連絡先はありません。",
    comingDue: "期限間近",
    tomorrow: "明日",
    next3days: "次の3日間",
    next5days: "次の5日間",
    next10days: "次の10日間",
    next30days: "次の30日間",
    comingDueNext5days: "期限間近 - 5日以内",
    entityDetails: "エンティティの詳細",
    requestsByEntity: "エンティティ別リクエスト",
    basedOnTheSelectedCategory: "選択したカテゴリーに基づく",
    requestCount: "リクエスト総数",
    selectedDay: "選択した日",
    editMember: "メンバーの編集",
    editMemberHeaderText: "選択したチームメンバーがアクセス可能なグループを編集",
    editaGroup: "グループの編集",
    editAGroupHere: "ここでグループを編集",
    selectAnotherFrame: "データを表示するには別のタイムフレームを選択してください。",
    emptyFrameShort: "続行するには、追加のエンティティを選択してください。",
    emptyFrame: "続行するには、追加のエンティティまたは別のタイムフレームを選択してください。",
    editMemberHeaderText: "選択したチームメンバーがアクセス可能なグループを編集",
    confirm: "確認",
    markCompleteModalInstrTextPart1: "このプロジェクトを完了してよろしいですか？",
    markCompleteModalInstrTextPart2: "このアクションを実行すると、元に戻せません。完了したプロジェクトはロールフォワードして、新しいプロジェクトを作成する時にテンプレートとして使用できます。",
    firstPage: "最初のページ",
    lastPage: "最後のページ",
    nextPage: "次のページ",
    prevPage: "前のページ",

    // Add Tag
	keyContacts: "主要な連絡先",
    customTags: "カスタムタグ",

    // Manage Tags
    manageTagInstructional: "ここで新しいカスタムタグを作成します。既存のカスタムタグを編集及び削除することもできます。連絡先にタグを付けると、EY Canvas Oversightプロジェクトで連絡先を自由に管理できます。",
    emptyCustomTagsList: "カスタムタグが作成されていません。",
    manageTagTitle: "カスタムタグを管理",
    manageTagLinkButton: "タグを編集",
    color: "色",
    tagName: "名前",
    tagDelete: "削除",
    tagCreate: "新規タグの作成",
    customTagsHeader: "カスタムタグ",

    //preparer assignment tile
    totalPreparerAssignments: "作成者の割当ての総数",
    inprogress: "進行中",
    preparerAssignments: "作成者の割当て",
    byAssignmentStatus: "割当て別ステータス",
    taskWithoutPreparerAssignments: "作成者の割当てがないタスク",
    tasksWithoutPreparerAssignments: "作成者の割当てがないタスク",
    preparerFilterTitle: "実施者",

    // reviewer assignment tile
    totalReviewerAssignments: "査閲者の割当ての総数",
    taskWithoutReviewerAssignments: "査閲者割当てのないタスク",
    tasksWithoutReviewerAssignments: "査閲者割当てのないタスク",
    reviewerFilterTitle: "査閲者",

    assignments: "割当て",
    notes: "ノート",
    preparerNotAssigned: "割当てられていない作成者",
    reviewerAssignments: "査閲者割当て",
    reviewerNotAssigned: "割当てられていない査閲者",
    basedOnPreparerAssignments: "作成者の割当てに基づく",
    basedOnPreparerAssignmentsOpenAndInProgress: "オープン及び進行中ステータスの作成者の割当てに基づく",
    basedOnReviewerAssignments: "査閲者の割当てに基づく",
    basedOnReviewerAssignmentsOpenAndInProgress: "オープン及び進行中ステータスの査閲者の割当てに基づく",

    statusOpen: "ステータス - オープン",
    statusInProgress: "ステータス - 進行中",
    statusClosed: "ステータス - クローズド",
    byPriorityLow: "優先度 - 低",
    byPriotityMedium: "優先度 - 中",
    byPriorityHigh: "優先度 - 高",
    byPriorityCritical: "優先度 - 重要",

    findingsLabel: "発見事項",
    riskLabel: "リスク",
    digitalAuditLabel: "デジタルオーディット",
    digitalAuditStrategy: "Digital Audit戦略",
    byDigitalAuditTypeLabel: "デジタルオーディット戦略別",
    basedOnProfileSelection: "プロファイルの選択に基づく",
    basedOnSelectionArchiveForm: "アーカイブフォームでの選択に基づく",
    MisstatementsByType: "タイプ別の虚偽表示",
    DeficienciesBySeverity: "重要度別不備",
    MisstatementsLabel: "虚偽表示",
    DeficienciesLabel: "不備",
    primarTeamDeficiencyHeader: "プライマリーチーム - {0}",
    componentRegionalTeamDeficiencyHeader: "リージョナル及び構成単位チーム - {0}",
    auditTileHeaderTextPrimary: "プライマリーチーム - {0}",
    componentRegionalTeamHeader: "リージョナル及び構成単位チーム - {0}",
    allTeamDeficiencyHeader: "全てのエンゲージメント - {0}",
    primarTeamMisstatementHeader: "プライマリーチーム - {0}",
    componentRegionalTeamMisstatementHeader: "リージョナル及び構成単位チーム - {0}",
    allTeamMisstatementHeader: "全てのエンゲージメント - {0}",
    deficiencyLabel: "不備",
    inherenRisktLabel: 'RA RU Risk of material misstatement',
    significantRiskLabel: "重要な",
    fraudRiskLabel: "不正",
    significantDeficiencyLabel: "重要な不備",
    materialWeaknessLabel: "開示すべき重要な不備",
    factualLabel: "事実に基づく",
    projectedLabel: "推定に基づく",
    judgmentalLabel: "判断に基づく",
    reclassificationLabel: "組替",
    totalDeficiencyLabel: "不備総数",
    totalRiskLabel: "リスク総数",
    totalRisksLabel: "リスク総数",
    totalDeficienciesLabel: "不備総数",
    totalMisstatementLabel: "虚偽表示総数",
    totalMisstatementsLabel: "虚偽表示総数",
    allEngagementHeader: "全てのエンゲージメント - {0}",
    noAuditSightGroupData: "<b>表示するグループ監査データはありません。</b> <br>トグルから<b>すべて</b>を選択すると、要約されたデータが表示されます。",
    noAuditTileDataPlaceholder: "表示するデータはありません。追加的のエンティティを選択すると続行します。",
    openReviewNotes: "レビューノートを開く",
    byPriorityLevel: "優先順位別",
    risks: "リスク",
    groupRoleLabel: "グループロール",
    totalRisks: "リスク総数",
    byType: "タイプ別",
    inherent: 'RA RU Risk of material misstatement',
    significant: "重要な",
    fraud: "不正",
    strategy: "戦略",
    notApplicable: "該当なし",
    customizableTable: "表のカスタマイズ",
    selectUpToOptionHeader: "最大{0}個の選択肢を選択",
    selectUpToThreeOptionHeader: "最大3つの選択肢を選択してください",
    selectUpToFourOptionHeader: "最大4つの選択肢を選択してください",
    psps: "PSPs",
    osps: "OSPs",
    hxpsps: "HxPSPs",
    totalSubstantiveProcedures: "実証手続総数",
    totalSubstantiveProcedure: "実証手続総数",
    totalITControls: "ITGCs及びITSPsの総数",
    totalITControl: "ITGC及びITSPの総数",
    testing: "テストする",
    nonTesting: "テストしない",
    auditStrategy: "監査戦略",
    totalControls: "統制総数",
    totalControl: "統制総数",
    removeProject: "プロジェクトの削除",
    removeProjectInstructionalText: "次のプロジェクトをアクティブなプロジェクトのリストから削除してよろしいですか？<br>プロジェクトを削除すると、アクセスできなくなります。",
    substantiveProcedures: "実証",
    controls: "統制",
    itlabel: "IT",

    //delegates removed
    userDelTitle: "私が権限委譲したメンバー",
    delTitleDetail: "ここに記載されているチームメンバーにアクセス権を移譲しました。 権限移譲先は、あなたがアクセスできるすべてのクライアントにアクセスできます。",
    delElseMsg: "まだ権限委譲するメンバーを追加していません",
    delegateTitle: "権限委譲するメンバーの削除",
    delegateMember: "権限委譲済",
    deleteMessage: "この権限委譲メンバーを削除してもよろしいですか?<br/>いったん削除すると、あなたの代理でプロジェクトの作成ができなくなります。 ",

    //Advanced filters.
    advancedFilters: "高度なフィルター",
    selectAll: "全てを選択",
    deselectAll: "全てを選択解除",
    applyFilters: "フィルターを適用",
    region: "リージョン",
    country: "国",
    city: "都市",
    state: "状態",
    advancedFiltersInstructionalText: "エンゲージメントデータを表示するエンティティを選択します。",
    advancedFiltersInstructionalTextLine2: "アクセス権のないエンティティは無効に見えます。アクセスが必要な場合はグループ管理者に相談してください。",
    engagementsSelected: "選択したエンゲージメント",
    filterYes: "はい",
    filterNo: "いいえ",

    //Group Audit
    pendingResponse: "対応待ち",
    primaryTileTitle: "プライマリーチームのステータス",
    reportingFormStatus: "レポーティングフォームのステータス",
    reportingForm: "レポーティングフォーム",
    summarizedForPrimaryTeams: "プライマリーチームの要約",
    primaryTileSubtitle: "送信済グループレポートフォーム",
    received: "受領済",
    dueToPrimaryTeam: "プライマリーチームへの回答が必要",
    sentToPrimaryTeam: "プライマリチームへ送信済",
    evidencePending: "保留中のエビデンス",
    evidenceComplete: "完了したエビデンス",
    componentTileTitle: "構成単位チームステータス",
    componentTaskStatus: "構成単位のタスクのステータス",
    componentTask: "構成単位タスク",
    comingsoonTaskStatus: "まもなく",
    summarizedForComponentTeams: "構成単位チームの要約",
    componentTileSubtitle: "受領済グループ監査タスク",
    unlinkedTask: "リンク解除されたタスク",
    unlinkedTasks: "リンク解除されたタスク",

    //Group Risk Assessment
    groupRiskAssessmentTitle: "リスク",
    groupRiskSummaryTitle: "グループリスク評価",

    // Reporting
    reportModifications: "報告書の限定",
    byReportType: "レポートタイプ別",
    notSelected: "未選択",
    unmodified: "未修正",
    modified: "修正済",
    reports: "報告書",
    opinions: "意見",
    modifiedReports: "限定付き報告書",
    modifiedOpinions: "除外事項付意見",
    adverse: "不適正",
    disclaimer: "不表明",
    qualification: "限定付",
    qualified: "限定付",
    engagementReportTooltip: "現在の日付以前の報告書日付のエンゲージメントのみがここに要約されます。すべてのエンゲージメントは以下に表示されます。",
    geography: "地域",
    standars: "基準",
    gaap: "GAAP",
    gaapUs: "GAAP US",
    ifrs: "IFRS",
    other: "その他",
    yearEndDate: "期末日",
    endDateOfPeriodCovered: "対象期間の終了日",
    reportDate: "報告書日",
    archiveDeadline: "アーカイブ期限",
    reportType: "レポートタイプ",
    opinionType: "意見のタイプ",
    taskStatus: "タスクステータス",
    exportData: "エクスポートデータ",
    exportToExcel: "エクスポート",
    orgChartEntity: "組織図のエンティティ",
    engagementId: "エンゲージメントID",
    contactName: "連絡先",
    contactEmail: "連絡先電子メール",
    statusInherent: 'RA RU By Type - Risk of material misstatement',
    statusSignificant: "タイプ別 - 特検",
    statusFraud: "タイプ別 - 不正",
    substantivePSPs: "実証 - PSPs",
    substantiveOSPs: "実証 - OSPs",
    substantiveHxPSPs: "実証 - HxPSPs",
    controlsTesting: "統制 - テストする",
    controlsNonTesting: "統制 - テストしない",
    iTTesting: "IT - テストする",
    iTNonTesting: "IT - テストしない",
    misstatementsFactual: "虚偽表示 - 事実に基づく",
    misstatementsProjected: "虚偽表示 - 推定に基づく",
    misstatementsJudgmental: "虚偽表示 - 判断に基づく",
    misstatementsReclassification: "虚偽表示 - 組替に関する",
    deficienciesDeficiency: "不備 - 不備",
    deficienciesSignificantdeficiency: "不備 - 重要な不備",
    deficienciesMaterialweakness: "不備 - 開示すべき重要な不備",
    statusComplete: "ステータス - 完了",
    statusInReview: "ステータス - レビュー中",
    statusInProgress: "ステータス - 進行中",
    statusOpen: "ステータス - オープン",
    statusNotSent: "ステータス - 未送信",
    statusReturned: "ステータス - 返信済み",
    statusDocumentationPending: "ステータス - 文書化を保留中",
    statusDocumentationComplete: "ステータス - 文書化を完了",
    statusReceivedbyEY: "ステータス - EYが受領済",
    statusAcceptedbyEY: "ステータス - EYが承諾済",
    statusOutstanding: "ステータス - 未了",
    noCompletedProjectsMessagePart1: "完了済みのプロジェクトはありません。",
    noCompletedProjectsMessagePart2: "プロジェクトオーナーの場合は、プロジェクトの完了をマークすることができます。完了したプロジェクトはロールフォワードして新しいプロジェクトを作成するときにテンプレートとして使用できます。",
    noCompletedProjectsMessage: "完了したプロジェクトはありません。<br>プロジェクトオーナーはプロジェクトを完了とマークできます。完了したプロジェクトはロールフォワードでき、新規プロジェクト作成時にテンプレートとして利用できます。",
    requests: "リクエスト",

    //Reporting readiness report
    week: "週",
    weeks: "週",
    readinessReportTitle: "レポートの準備",
    taskCompletionByEngagement: "エンゲージメント別タスクの完了",
    readinessLegendTitle: "報告書日間近",
    basedOnReportDateProximityForEachEngagement: "各エンゲージメントのレポート日の近さに基づく",

    //ReportCompletion
    taskCompletionStatus: "タスク完了のステータス",
    taskCompletionByLocation: "ロケーション別タスクの完了",
    basedOnCompletedTasksForEachEngagement: "各エンゲージメントの完了したタスクに基づく",
    byGeography: "地域別",
    taskCompletion: "タスクの完了",
    completedTasks: "完了したタスク",

    engagementArchived: "このエンゲージメントはアーカイブ済です。データは利用できません。",
    externalUsersNoActiveProjMessage: "アクティブなプロジェクトはありません。アクセスするにはEYチームメンバーに相談してください。",

    //Error Messages
    networkErrorMessage: "アプリケーションネットワークにエラーが生じています。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    genericErrorMessage: "選択した操作は完了できませんでした。ページを更新して、再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。 ",
    otherProjectPlaceholder: "EY Canvasエンゲージメントは、ここにリストされたEY Canvas Oversightプロジェクトに接続しています。あなたにはこれらのプロジェクトへのアクセス権がありません。アクセス権を入手するには、プロジェクトオーナーまたはグループ管理者に相談してください。",
    noProjectsAvailable: "利用可能なプロジェクトがありません。",
    completedProjectPlaceholder: "完了したEY Canvas Oversightプロジェクトのリストはこちらです。新しいプロジェクトを作成する時に、完了したプロジェクトをテンプレートとして使用するには、 <b> ロールフォワード </b> オプション選択してください。",
    completedNotProjectPlaceholder: "完了したプロジェクトはありません。<br>プロジェクトオーナーはプロジェクトを完了とマークできます。完了したプロジェクトはロールフォワードでき、新規プロジェクト作成時にテンプレートとして利用できます。",

    //Log out and time out modal
    logoutModalTitle: "セキュリティ保護の観点から自動ログアウトされました",
    sessionTimerMsgLine1: "操作が行われないため作業セッションはまもなく中断されます。",
    sessionTimerMsgLine2: "セキュリティ上の理由から、EY Canvas Oversightセッションは最後の操作から30分後に自動で終了します。",
    sessionTimerMsgLine3: "現在のセッションは {0}分後に終了します。",
    sessionTimerMsgLine4: "ログインを継続する場合はクリックしてください。",
    modalContinueButton: "<b>続行</b>",
    modalLogoutButton: "ログアウト",
    modalCloseButton: "閉じる",
    countryNotAvailable: "国は利用できません",
    regionNotAvailable: "利用可能なリージョンなし",
    notAvailable: "利用不可",
    signout: "サインアウト",
    engagementTypeNotAvailable: "エンゲージメントタイプは利用不可",

    // Admin portal
    administration: "管理",
    mainPageInstructionalText: "EY Canvas Oversight管理ポータルへようこそ",
    manageProjectsFormatted: "プロジェクトの <br />管理",
    manageUsersFomatted: "ユーザーの <br />管理",
    manageAdminsFormatted: "Oversight管理者の <br />管理",
    homeLabel: "ホーム",
    userNotFoundError: "ユーザーが見つかりません。",
    manageUsersInstructionalText: "GUIを入力してユーザーを検索する",
    selectRole: "ロールを選択",
    role: "ロール",

    //Manage User
    manageUsersTitle: "ユーザー管理",
    otherProjectsTabTitle: "別のプロジェクト",
    validGuiErrorMsg: "有効なGUIを入力してください",
    accessibleProjects: "アクセス可能なプロジェクト",
    delegates: "権限委譲",
    projectID: "プロジェクトID",
    projectStatus: "プロジェクトステータス",
    gui: "GUI",
    emailAddress: "Eメールアドレス",
    userRole: "ユーザーロール",
    userID: "ユーザーID",
    noResultMessage: "検索条件に合致する結果なし。",
    noResultFound: "レコードが見つかりません。",
    userDetails: "ユーザーの詳細",
    active: "アクティブ",
    inActive: "非アクティブ",
    manageAdmins: "EY Canvas Oversight管理者の管理",
    manageAdminsInstructionalText: "すべてのEY Canvas Oversight管理者は以下です。管理者のロールの編集、追加、削除ができます。",
    adminReader: "アプリケーション管理者リーダー",
    adminWriter: "アプリケーション管理者ライター",
    superAdmin: "アプリケーション特別管理者",
    revertChanges: "変更を元に戻す",
    unSavedChanges: "未保存の変更",
    unSavedChangesMessage: "続行すると失われる未保存の変更があります。<br/> 続行するには <b>確認</b>を選択してください。または<b>キャンセル</b> を選択して、元のページに戻り、変更を保存してください。",
    addNewAdmin: "新しい管理者を追加する",
    addEYContactInstructions: "名前またはメールアドレスを入力し、Enterキーを押して結果を確認してください。新しいOversight管理者を追加するにはロールを選択してください。",

    // ManageProjects
    orgChartEntities: "組織図のエンティティ",
    manageProjectsInstructionalText: "プロジェクトIDを入力してプロジェクトを検索してください。",
    projectDetails: "プロジェクトの詳細",
    parentEntity: "親エンティティ",
    connectedGroups: "接続されたグループ",
    validProjectIDError: "有効なプロジェクトIDを入力",
    addNewMember: "メンバーの追加",
    adminAddMemberInstructionalText: "ユーザーを検索し追加するグループを選択してください",
    currentApplication: "現在のアプリケーション",

    //Software Update
    softwareUpdate: "ソフトウェアのアップデート",
    updateNow: "今すぐアップデート",
    updateMsg: "ソフトウェアのアップデートが EY Canvas Oversightで利用可能です。今すぐアップデートを選択し必要なアップデートをダウンロード、インストールしてください。Webページは更新されます。",

    //ContactDB
    placeholderForSearch: "検索",
    contactClearAll: "全てクリア",
    contactShowMoreFilters: "追加",
    contactListFilter: "連絡先リストにアクセス",
    dashboardAccessFilter: "ダッシュボードにアクセス",
    groupRoleFilter: "グループロール",
    tagFilter: "タグ",
    countryFilter: "国",
    serviceLineFilter: "サービスライン",
    typeFilter: "タイプ",
    roleFilter: "ロール",
    dashboardAccess: "ダッシュボードにアクセス",
    contactList: "連絡先リスト",
    noEntitiesMessage1: "表示するデータがありません",
    noEntitiesMessage2: "追加のエンティティを選択して続けてください",
    noContacts: "このエンティティには連絡先がありません",
    engagementsContacts: "エンゲージメント",
    manuallyAdded: "手作業による追加",
    dashboardViews: "画面",
    columnName: "名前",
    columnEmail: "Eメール",
    columnEngagement: "エンゲージメント",
    columnType: "タイプ",
    columnRole: "ロール",
    columnServiceLine: "サービスライン",
    columnDashboard: "ダッシュボードにアクセス",
    columnDashboardView: "ダッシュボード画面",
    columnContactList: "連絡先リストにアクセス",
    columnTags: "タグ",
    columnEntity: "エンティティ",
    noResults: "結果がありません",
    noResultsAvailable: "利用可能なデータがありません",
    searchContacts: "連絡先の検索",
    selectedContacts: "選択された連絡先",
    tag: "タグ",
    manageAccess: "アクセスの管理",
    formLengthMessage: "文字数は {number} 文字を超えられません",
    viewMoreColumns: "表示列を増やす",
    projectOwnerBadge: "プロジェクトオーナー",
    entityAdminBadge: "エンティティ管理者",
    eyTeam: "EYチーム",
    clientTeam: "クライアントチーム",
    userProfile: "ユーザープロファイル",
    columnGroupRiskAssessment: "グループリスク評価にアクセスする",
    externalUserDenyMessage: 'RA RU External users cannot be granted access to the Group risk assessment module.',
    //ContactDB - Toolbar
	toolbarAddContact: "連絡先 追加",
	toolbarAccessLog: "アクセス ログ",
	toolbarMessageLog: "メッセージ ログ",
	toolbarCustomizeTable: "テーブル カスタマイズ",
	toolbarExportData: "データ 出力",
    toolbarManageAccess: "アクセス 管理",
    toolbarDefineAttributes: "属性の 定義付け",
    toolbarGenerateMessage: "メッセージ 作成",
    toolbarTags: "タグ",
    toolbarRemove: "リムーブ",

    //ContactDB - Add Contact Modal
    addContactLabel: "連絡先の追加",
    addContactTitle: "連絡先の追加",
    addContactInstructional: "EY Canvas Oversightのプロジェクトに1つ以上の連絡先を追加します。追加した連絡先がダッシュボード又は連絡先リストへのアクセスを必要とする場合、ここでアクセス権を付与できます。",
    columnEntities: "エンティティ",
    noEntities: "なし",
    duplicatedUser: "は既に連絡先として追加されています。連絡先リストからアクセス権を管理できます。",
    accessToDashboard: "ダッシュボードにアクセスする",
    dashBoardsViews: "ダッシュボードアクセス/画面",
    placeholderEntities: "エンティティ",
    placeholderAccess: "アクセス",
    placeholderAttributes: "属性",
    placeholderTags: "タグ",
    projectOwnerAccessLabel: 'RA RU Project Owner access',
    entityAdminAccessLabel: 'RA RU Entity Admin access',
    accessToContactListLabel: "連絡先にアクセスする",
    saveContactLabel: "保存",
    cancelContactLabel: "キャンセル",
    noContactsAdded: "まだ連絡先が追加されていません",
    noCustomColumns: "あなたのプロジェクトにはカスタム列が作成されていません。",
    toggleContactYes: "はい",
    toggleContactNo: "いいえ",
    mustSelectOneEntity: "続行するには、少なくとも一つのエンティティを選択しなければなりません。",
    mustSelectOneView: "EY Canvas Oversightのダッシュボードにアクセス権を付与したすべての連絡先に対し少なくとも一つのビューを選択してください。",
    mustBeOnwerOrAdministrator: "このアクションを実行するにはプロジェクトオーナーもしくは管理者である必要があります。続行するには選択したエンティティを更新してください。",
    cannotEditAccessForProjectOwners: "プロジェクトオーナーのアクセス権を編集できません:  {list}",
    attributesLabel: "属性",
    externalUserDomainMismatch: "ドメインは、選択した 1 つ以上のエンティティに対して許可されていません。エンティティ設定フローに必要なドメインを追加して、再試行してください。",
    projectOwnerAccessToogleInfo: 'RA RU A Project owner has full permissions for an EY Oversight project.',
    entityAdminAccessToogleInfo: 'RA RU An Entity admin has Entity specific permissions to perform administrative tasks, as needed.',

    //ContactDB-CustomizeTable Modal
    customizeTableModal: "表の編集",
    InstructionalTextCustomizeTableModal: 'RA RU Select the columns you would like to view.',
    cancelCustomizeTable: "キャンセル",
    saveCustomizeTable: "保存",
    tooltipCustomizeTable: "表のカスタマイズ",
    standardColumns: "標準の列",
    customColumns: "カスタム列",
    closeTitleModal: "閉じる",
    addCustomColumn: "カスタム列の追加",
    editCustomColum: "カスタム列の編集",
    addCustomColumnLegend: "カスタム列を使用すると、連絡先に関する追加の属性を取得及び管理できます。このプロジェクトにおいて5つまでカスタム列を作成できます。カスタム列を作成後、1つ以上の連絡先を選択し、属性を定義付けできます。カスタム列を削除する場合、コンタクトの属性も削除されます。",
    deleteCustomColumnLegend: " <b>削除</b> アイコンを選択して、カスタム列を削除します。続行すると、プロジェクトで使用できなくなります。連絡先に従前適用した属性も削除されます。",
    customColumnName: "列の名前",
    attribute: "属性",
    attributes1to5: "属性(1-5)",
    visibleToExternal: "外部連絡先に表示",
    noCustomColumnMsg: 'RU No custom column added',

    //ContactDB - Add Contact Modal
    filterTooltip: "フィルター",
    searchTitletip: "検索",
    addExternalContactColumnName: "名前",
    addExternalContactColumnDomain: "ドメイン",
    confirmDomain: "ドメインの確認",

    //ContactDB - Profile Modal
    profileModalTitle: "プロファイル",
    profileModalAccessSection: "アクセス",
    profileModalCustomAttributesSection: "カスタム属性",
    profileModalDashboardSection: "ダッシュボードビュー",

    //ContactDB - Generate Message
    selectMessageRecipients: "メッセージ受信者を選択する",
    notification: "通知",
    generateMessage: "メッセージの生成",
    gmInstructionalText: "選択した連絡先にEメール又は通知を送ります。通知は内部の連絡先にのみ送信可能です。Eメールは内部及び外部の両方の連絡先に送信可能です。",
    messageType: "メッセージタイプ",
    messageRecipient: "メッセージ受信者",
    selectContactsNow: "今すぐ連絡先を選択",
    useSelectedContacts: "選択した連絡先を使う",
    moreFilters: "+ 追加のフィルター",
    countries: "国",
    groupRoles: "グループロール",
    groupRole: "グループロール",
    roles: "ロール",
    role: "ロール",
    serviceLines: "サービスライン",
    serviceLine: "サービスライン",
    contatcs: "連絡先",
    singularContact: "連絡先",
    singularEngagement: "エンゲージメント",
    allContact: "全ての連絡先",
    allEntitles: "全てのエンティティ",
    allCountries: "全ての国",
    allGroupRoles: "全てのグループロール",
    allEngagements: "全てのエンゲージメント",
    allServicesLines: "全てのサービスライン",
    allRoles: "全てのロール",
    subject: "件名",
    removeTooltip: "リムーブ",
    fromEntity: "エンティティより",
    fromEngagement: "エンゲージメントより",
    notificationMessage: "通知メッセージ",
    linkLabel: "リンクラベル（任意）",
    link: "リンク（任意）",
    fromEntityNotification: "エンティティより",
    mustSelectOne: "1つ以上の連絡先を選択して続けてください",
    emailSentMsg: "Eメールのメッセージが選択した連絡先に生成されました",
    notificationSentMsg: "通知が選択した連絡先に送信されました",
    messageFrom: "メッセージ送信元",
    duplicateMessage: "メッセージの複製",
	someEntities: '{0} RA RU entities selected',

    //ContactDB - Message Log
    messageLogInstruction: "エンティティにより送信されたメッセージのリストをレビューして下さい。フォローアップメッセージを送る必要がある場合は受信者の前回のメッセージを複製することができます。",
    messageLogTitle: "メッセージログ",
    today: "今日",
    yesterday: "昨日",
    thisWeek: "今週",
    lastWeek: "先週",
    twoWeeksAgo: "2週間前",
    older: "過去",
    notificationTo: "通知先",
    emailTo: "Eメール送信先",
    sentBy: "送信者",
    from: "From",
    date: "日付",
    time: "時間",
    subject: "件名",
    multiContatcsLowerCase: "連絡先",
    singleContactLowerCase: "連絡先",
    seeMore: "表示を増やす",
    seeLess: "表示を減らす",
    messageLogEmptyMessage: "メッセージはまだ送信されていません。",
    messageLogFileExported: "メッセージログ",
    typeColumnToExportToExcel: "タイプ",
    sentByColumnToExportToExcel: "送信者",
    fromColumnToExportToExcel: "From",
    dateColumnToExportToExcel: "日付",
    timeColumnToExportToExcel: "時間",
    subjectColumnToExportToExcel: "件名",
    contactsColumnToExportToExcel: "連絡先",
    emailExportToExcel: "Eメール",
    notificationExportToExcel: "通知",

    //ContactDB - Access Log
    accessLog: "アクセスログ",
    accessLogInstructional: "以下に表示されたチームメンバーをレビューし連絡先として追加するかリムーブするか決定してください。",
    addAll: "すべて追加",
    removeAll: "すべてリムーブ",
    ignoreAll: "すべて無視",
    contactsToAddEmpty: "現在追加可能な連絡先はありません",
    contactsToRemoveEmpty: "現在リムーブ可能な連絡先はありません",
    ignore: "無視",
    addAllConfirmationModal: "1 人以上のユーザーが、エンティティによって許可されていないドメインを持っています。「続行」 をクリックすると、ユーザーを連絡先リストに追加できます。ドメインがインポートされ、エンティティの許可されたドメインの一覧に追加されます。",
    addConfirmationModal: "ユーザーが、エンティティによって許可されていないドメインを持っています。「続行」 をクリックすると、ユーザーを連絡先リストに追加できます。ドメインがインポートされ、エンティティの許可されたドメインの一覧に追加されます。",

    // ContactDB - Message Log - Filter
    messageTypeFilter: "メッセージタイプ",
    sentByFilter: "送信者",
    fromEntityFilter: "エンティティより",
    toEntityFilter: "エンティティへ",
    toCountryFilter: "国へ",
    toGroupRoleFilter: "グループロールへ",
    toEngagementFilter: "エンゲージメントへ",
    toServiceLineFilter: "サービスラインへ",
    toRoleFilter: "ロールへ",

    //ContactDB - Define Attributes
    defineAttributes: "属性の定義付け",

    // ContactDB Edit Entity Modal
    // Step 2 - Edit Entity Modal
    addAnotherEntityAdministrator: "別のエンティティ管理者を追加する",
    editEntity: "エンティティの編集",
    entityAdministrators: "エンティティ管理者（任意）",
    editEntityAdministratorsInstruction: "1人以上のエンティティ管理者を追加することができます。管理者はエンティティに連絡先を追加したり、EY Canvas Oversightへのアクセスを設定することができます。",
    editEntityDomainInstruction: "外部チームメンバーは、このエンティティがEY Canvas Oversightにアクセスするための有効なドメインを持っている必要があります。システムは、セットアップウィザードのステップ4で、接続されたEY Canvasエンゲージメントから承認済みドメインをインポートします。このエンティティに他の外部チームメンバーを招待する場合は、1 つ以上のドメインを追加します。ドメインは、メールアドレスの@記号の後の文字を指します。",
    level: "レベル｛0｝",

    // ContactDB Remove Contacts
    removeIcon: "リムーブ",
    removeContactTitle: "RU - Remove contacts",
    removeInstructionalText: "プロジェクトからこれらの連絡先をリムーブしてよろしいですか？これらの連絡先が複数のエンティティに属している場合、すべてのエンティティからリムーブされます。個別のエンティティから連絡先をリムーブする場合は、連絡先のアクセスの編集を選択してください。",
    removeSelectedContacts: "選択した連絡先",

    domainNotPermitted: "1人または複数のエンティティの管理者のドメインがこのエンティティにおいては許可されていません",
    listView: "リスト表示",
    cardView: "カード表示",

    recordsNotAvailable: "利用できるレコードはありません",

    // Project Layout Update
    welcomeLabel: "ようこそ",
    activeProjectsInstructionalText: "ここに表示されたEY Canvas Oversightのプロジェクトへアクセス可能です。モジュールを選択し移動するか、カウントをクリックし各プロジェクトの詳細を表示します。",
    otherProjectsInstructionalText: "このEY Canvas エンゲージメントはここに表示されたEY Canvas Oversightプロジェクトに関連付けられています。これらのプロジェクトにアクセスする権限はありません。アクセス権を得るにはプロジェクトオーナー又はエンティティ管理者に連絡してください。",
    completedProjectsInstructionalText: "ここに表示されたEY Canvas Oversightプロジェクトは完了済です。 <b>ロールフォワード</b>を選択すると、新規プロジェクト作成の際にテンプレートとしてこの完了プロジェクトを使用できます。",
    goToLabel: "Go To",
    entityAdmins: "エンティティ管理者",
    entityAdmin: "エンティティ管理者",
    keyContacts: "主要な連絡先",
    keyContact: "主要な連絡先",
    contactListLabel: "コンタクトリスト",
    draftlabel: "ドラフト",
    projectWizard: "プロジェクトウィザード",
    noEntityAdminsAdded: "関連付けられたエンティティ管理者はいません",
    addProjectOwner: "プロジェクトオーナーを追加",
    addProjectOwnerInstrText: "名前またはEメールを使用してユーザーを検索し、選択したプロジェクトのプロジェクトオーナーとして追加します。",
    projectSummary: "プロジェクトサマリ",
	privacyNotice: "プライバシー通知",
    groupOversightProject: "グループOversight プロジェクト（New!）",
    groupOversightProjectTooltip: "<b>グループOversight プロジェクト</b>では、EY Oversightプロジェクトを作成しているプラ​​イマリー及び/又はリージョンのEY Canvasエンゲージメントを特定できます。 EY Canvasグループ構造で識別されたリージョン及び/又は構成単位のEY Canvasエンゲージメントは、EY Oversightプロジェクト設定の一部として<b>自動的に</b>登録されます。 <br><br>さらに、このようなプロジェクトはグループリスク評価モジュールにアクセスでき、プライマリー、リージョン及び/又は構成単位のエンゲージメントが実施したリスク評価アクティビティが表示されます。",
    oversightProject: "Oversightプロジェクト（法定監査）",
    oversightProjectTooltip: "Oversightプロジェクト（法定監査）では、クライアントを手動で選択することで、EY Oversightプロジェクトを作成するEY Canvasエンゲージメントを選択できます。",

    // Group Risk Assessment
    noGroupRiskAssessmentForSelection: "このOversightプロジェクトにはグループリスク評価アクティビティはありません。",
    engagementData: 'RA RU Engagement data',
    engagementDetails: 'RA RU Engagement details',
    reconciliations: 'RA RU Reconciliations',
	nextComponent: 'RA RU Next component',
	prevComponent: 'RA RU Previous component',
	allAccounts: 'RA RU All accounts',
    generateEmail: 'RA RU Generate email',
	reconciliationDetailInstructional: 'RA RU The information below summarizes the total accounts and risks related to the component team in the primary team EY Canvas group structure. Accounts and risks should be mapped to the equivalent account and risk in the component team EY Canvas engagement.',
	primaryTeamAccountName: 'RA RU Primary team account name',
	componentTeamAccountName: 'RA RU Component team account name',
	designation: 'RA RU Designation',
	openAccounts: 'RA RU Open accounts',
	componentTeamAccounts: 'RA RU Component team accounts',
	mapAccountsMessage: 'RA RU Each primary team account should have at least one mapped component team account. {button} to get started.',
    primaryTeamAccountStatus: 'RA RU Primary team account status',
	totalAccounts: 'RA RU Total accounts',
	assessedAccounts: 'RA RU Assessed accounts',
	primaryTeamRiskStatus: 'RA RU Primary team risk status',
	openRisks: 'RA RU Open risks',
	assessedRisks: 'RA RU Assessed risks',
	totalRisks: 'RA RU Total risks',
	primaryTeamRiskDesignationAndName: 'RA RU Primary team risk designation and name',
	primaryTeamAccountsRelatedToRisk: 'RA RU Primary team account(s) related to risk',
	componentTeamRisksAndRelatedAccounts: 'Component team risks and related account(s)',
	relateRisks: 'RA RU Relate risks',
	relateRisksMessage: 'RA RU Each primary team account should have at least one mapped component team risk. {button} to get started.',
    pspIndexesHeader: 'RA RU PSP',
	pspIndexes: 'RA RU PSP index(es)',
	markAssessed: 'RA RU Mark assessed',
    markReOpen: 'RA RU Re-open',
    markAssessedSuccessMessage: 'RU The related account has successfully been marked assessed.  To review the account, go to the assessed view.',
	reopenAssessedAccount: 'RA RU Re-open',
	reopenAssessedAccountMessage: 'RA RU If changes need to be made to accounts that have already been marked assessed, {button} the account. This account grouping will appear in the Open bucket.',
	reopenSuccessMessage: 'RA RU The related account has successfully been re-opened.  To review the account, go to the open view.',
	riskMarkAssessedMessage: 'RA RU Review primary and component team risks that are related. Once there is a complete mapping, {button}.',
    riskWasPreviousAssessedMessage: "RA RU This primary and component team risk grouping was previously marked assessed but there were changes to the risk assessment. Review primary and component team risks to ensure the mapping is still correct. Once complete, {button}.",
    riskMarkOpenMessage: 'RA RU If changes need to be made to risks that have already been marked assessed, {button} the risk. This risk grouping will appear in the Open risks view.',
    teamAccountMappedMessage: 'RA RU Review primary and component team accounts that are mapped. Once there is a complete mapping, {button}.',
    teamAccountWasPreviousAssessedMessage: 'RA RU This primary and component team account grouping was previously marked assessed but there were changes to the account(s). Review primary and component team accounts to ensure the mapping is still correct. Once complete, {button}.',
	createComment: 'RA RU Create comment',
	editComment: 'RA RU Edit comment',
    commentTitle: 'RA RU Comment',
	createCommentInstructionalText: 'RA RU Enter comment details for the selected account or risk and select \'Save\' to finish.',
	editCommentInstructionalText: 'RA RU Edit comment details for the selected account or risk and select  \'Save\' to finish.',
    lastModified: 'RA RU Last modified',
	addComment: 'RA RU Add comment',
	accountDescription: 'RA RU Select Open accounts to view Primary team accounts that have not been related to Component team accounts and marked assessed. Select Assessed accounts to view Primary team accounts that have been assessed.',
	riskDescription:'RA RU Select Open risks to view Primary team risks that have not been related to Component team risks and marked assessed. Select Assessed risks to view Primary team risks that have been assessed.',
    successAssessedMessage: 'RA RU The related risks have successfully been marked assessed.  To view the risks, go to the assessed view.',
    successReOpenMessage: 'RA RU The related risks have successfully been re-opened.  To view the risks, go to the open view.',  

	// Relate risks modal
	relateRisksModalTitle: 'RA RU Relate component team risks to Primary team risks',
	relateRisksModalInstructionalText: 'RA RU Select Component team risk(s) below to relate to the selected Primary team risk.',
	primaryRegionTeamRisk: 'RA RU Primary team risk:',
	primaryTeamRiskLabel: 'RA RU Primary team risk',
	thereIsNoDataToDisplayForThisSelection: 'RA RU There is no data to display for this selection.',
	accountAndAsssociated: 'RA RU Account(s) and associated PSP(s)',
	noAccountOrPspAssociated: 'RA RU There is not account or associated PSP index.',
    disabledRegionComponentTeamRiskLabel: 'RA RU This Component team risk is already mapped to another Primary team risk. A Component team risk can only be mapped to one Primary team risk. Select \'Relate risks\' for the relevant Primary risk to unrelate this risk, as applicable.',
    selectOneOrMore: 'RA RU Select one or more',

    relateAccountsModalTitle: 'RA RU Relate component team accounts to Primary team accounts',
    relateAccountName: 'RA RU Primary team account:',
	relateAccountpspIndex: 'RA RU Primary team PSP index:',
	relateAccountpspIndexes: 'RA RU Primary team PSP indexes:',
    relateAccountInstructionalText: 'RA RU Select Component team account(s) below to relate to the selected Primary team account.',
    pspIndexcountLabel: 'RA RU PSP indexes related to the Primary/Region team account',
    relateAccounts: 'RA RU Relate accounts',

    viewComponentTeamAccountsText: 'RA RU View component team accounts not related and/or not applicable',
	componentTeamAccountsModalTitle:'RA RU Component team accounts not related and/or not applicable',
	componentTeamAccountsModalInstructionalText: 'RA RU Component team accounts should be related to a primary team account. Return to the underlying page to relate accounts. If the component team account is not applicable to the group audit, mark the account as \'Not applicable\'.',
	componentTeamAccountsModalNotApplicableInstructionalText: 'RA RU Not applicable component team accounts are marked this way because they are not applicable to the group audit. If an account is listed below in error, move the account back to \'Not related\' in order to relate this account to a Primary team account.',
    notRelatedTab: 'RA RU Not related',
	notApplicableTab: 'RA RU Not applicable',
    unmapped: 'RA RU Unmapped',
	unrelate: 'RA RU Unrelate',
	action: 'RA RU Action',
	notApplicableActionTitletip: "RA RU Selecting 'Unrelate' will move the risk to the 'Not related' tab. Risks that are 'Not related' should either be related to a Primary team risk or be marked 'Not applicable' if they are not applicable to the group audit.",
	notRelatedActionTitletip: "RA RU Selecting 'Not applicable' will move the risk to the 'Not applicable' tab. Component team risks that are 'Not applicable' are not applicable to the group audit.",

	higherInheritRisk: 'RA RU Higher inherent risk',
	lowerInheritRisk: 'RA RU Lower inherent risk',
	riskAssociated: 'RA RU Risk associated',
	riskAssociatedHigher: 'RA RU Risk associated and contributes to the higher inherent risk',
    
	viewComponentTeamRisks: 'RA RU View component team risks not related and/or not applicable',
	unmappedRisksModalTitle: 'RA RU Component team risks not related and/or not applicable',
	unmappedRisksModalInstructional: "RA RU Component team risks should be related to a primary team risk. Return to the underlying page to relate risks. If the component team risk is not applicable to the group audit, mark the risk as 'Not applicable'.",
    notApplicableRisksModalInstructional: "RA RU Not applicable component team risks are marked this way because they are not applicable to the group audit. If a risk is listed below in error, move the risk back to 'Not related' in order to relate this risk to a Primary team risk.",
	added: 'RA RU Added'
};

export const temporaryLabels = {
    dryDock: "ドライドック",
    darkMode: "ダークモード",
    dashboard: "ダッシュボード",
    projects: "プロジェクト",
    scopeStrategy: "スコープ及び戦略",
    accountSummary: "勘定科目サマリー",
    scotSummary: "SCOTサマリー",
    craSummary: "CRAサマリー",
    itSummary: "ITサマリー",
    SPSummary: "Substantive Evaluation Summary",
    auditPlan: "監査計画",
    conclusion: "総括",
    findings: "発見事項",
    changesReport: "報告書日後の変更",
    teamMember: "チームメンバーの独立性",
    archiveChecklist: "アーカイブチェックリスト",
    enagagementmanagement: "エンゲージメント管理",
    integration: "統合",
    guidedWorkflow: "ワークフローガイド",
    copyrightMessage: "Copyright © <year>. All rights reserved"
}

export const createGRAProjectLabels = {
    creationInstructional: "RU - Введите название проекта и выберите одно основное или региональное задание EY Canvas из списка ниже, чтобы создать проект EY Oversight. <br> На основе выбранного задания задания EY Canvas, определенные в структуре группы EY Canvas, будут автоматически заполнены как часть настройки этого проекта. Щелкните {link} для получения дополнительной информации о EY Canvas Oversight.",
    projectName: labels.projectName,
    engagements: labels.engagementsLabel,
    searchPlaceholder: "EY Canvasエンゲージメント名、ID又はクライアント名で検索",
    noAccessToEng: "EY Canvasエンゲージメントにアクセスできません。",
    noDataToDisplay: labels.noDataFound,
    save: labels.save,
    cancel: labels.cancelLabel,
    engagementsRequiredMessage: "保存するエンゲージメントを少なくとも1つ選択してください。",
    userGuideLinkText: 'RU User Guide'
}

export const deleteCommentModalLabels ={
	titleText: 'RA RU Delete comment', 
	instructionalText: 'RA RU Are you sure you want to delete the comment?', 
	triggerText: 'RA RU Delete', 
	confirmLabel: 'RA RU Confirm', 
	cancelLabel: 'RA RU Cancel', 
	closeLabel: 'RA RU Close',
}


export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "プライマリー"
    },
    {
        id: GARoleTypeId.Region,
        label: "リージョン"
    },
    {
        id: GARoleTypeId.Component,
        label: "構成単位"
    }
];

export const engagementTableLabels = {
    engagementName: "エンゲージメント名",
    clientName: labels.clientName,
    type: labels.typeLabel,
    gaRoleType
}

export const formLabels = {
    required: labels.required,
    maxLength: labels.formLengthMessage
}

export const activityLogTypes = {
    ProjectCreated: "プロジェクトの作成日",
    GAComponentCreated: "追加された構成単位",
    GAComponentRemoved: "削除された構成単位",
    GAComponentUnlinked: "リンク解除された構成単位",
    AccountAdded: "追加された勘定科目",
    AccountRemoved: "削除された勘定科目",
    AccountDesignationChanged: "変更された勘定科目の指定",
    AccountEstimateChanged: "変更された会計上の見積り",
    AccountExecutionTypeChanged: "変更された実証手続のタイプ",
    AssertionAssociated: "関連するアサーション",
    AssertionUnassociated: "関連付けられていないアサーション",
    AssertionInherentRiskChanged: "固有リスクの変更",
    AssertionControlRiskDesignationChanged: "統制リスクの指定の変更",
    RiskCreated: "作成されたリスク",
    RiskRemoved: "削除されたリスク",
    RiskAssociated: "関連するリスク",
    RiskUnassociated: "関連付けられていないリスク"
};

export const activityTableLabels = {
    sourceEngagement: "ソースエンゲージメント",
    activityType: "アクティビティタイプ",
    objectImpacted: "影響を受けるオブジェクト",
    relatedObjectImpacted: "影響を受ける関連オブジェクト",
    relatedSecondaryObjectImpacted: "影響を受ける第2関連オブジェクト",
    activityDate: "アクティビティの日付"
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: 'RA RU Component team risk name',
	details: 'RA RU Details',
};

export const riskTypes = [
	{id: '1', label: 'RA RU Significant Risk'},
	{id: '2', label: 'RA RU Fraud Risk'},
	{id: '3', label: 'RA RU Inherent Risk'}
];

export const engagementLabels = {
    accountName: 'RA RU Account / disclosure name',
    accountTypeName: 'RA RU Designation',
    canvasEngagementId: 'RA RU Engagement Id',
    controlRiskTypeName: 'RA RU Control risk',
    engagementDescription: 'RA RU Engagement name',
    inherentRiskTypeName: 'RA RU Inherent risk',
    assertionName: 'RA RU Assertion',
    pspIndexTitle: 'RA RU PSP Index',
    riskName: 'RA RU Risk name',
    riskTypeName: 'RA RU Risk type',
    relatedTasks: 'RA RU Related tasks',
    taskStatus: "タスクステータス",
    controlRiskAssessment:'RA RU Control risk assessment',
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
    lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
    lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
	groupRiskAssessmentInstructional: "RA RU Click on a component below to view the accounts and the risks of material misstatement related to the component and communicated in the group audit instructions. Relating these accounts to the corresponding objects in a connect component team engagement allows the Primary team (or regional team) to compare the accounts and risks of material misstatement related to the component in the Primary Team engagement to those created in the component team engagement.<br><br>The Activity feed can be used to view changes that have been made to the accounts and risks in connected component team engagements.<br><br>The EY Canvas Oversight Group risk assessment functionality can support effective project management by a Primary Team in a group audit. However, this functionality is not intended to provide, document or generate audit evidence. Further, it is not intended to replace the Primary Team's involvement in the component team's work, including review of component teams reporting deliverables. We do not include screenshots or data exported from EY Canvas Oversight in the Primary Team's EY Canvas as evidence of the Primary Team's involvement in, or supervision of, the work of component teams."
}

export const reconciliationsTableLabels = {
    show: labels.show,
	noDataToDisplay: 'RA RU There is no data to display for this table.',
	unselectedEntities: 'RA RU There is no reconciliation data for this EY Oversight project. Relate components to accounts in the Group instructions flow in your Primary team EY Canvas engagement for reconciliation data to be displayed here.',
	columns: {
		components: 'RA RU Components',
		open: 'RA RU Open',
		assessed: 'RA RU Assessed',
		total: 'RA RU Total'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
}

export const relateAccountsTableLabels = {
    show: labels.show,
    noDataToDisplay: labels.noDataFound,
    columns: {
        accountName: 'RA RU Component team account',
        pspIndexes: 'RA RU PSP indexes'
    },
    nextComponent: labels.nextComponent,
    prevComponent: labels.prevComponent,
    relateAccountTableDisabledRowToolTip: 'RA RU This Component team account is already mapped to another Primary team account. A Component team account can only be mapped to one Primary team account. Select \'Relate accounts\' for the relevant Primary account to unrelate this account, as applicable.'
}

export const notRelatedAccountsTableLabels = {
    show: labels.show,
    noDataToDisplay: labels.noDataFound,
    columns: {
        accountName: relateAccountsTableLabels.columns.accountName,
        pspIndexes: 'RA RU PSP index(es)',
        notRelated: {
            actionColumnName: labels.action,
            titleTip: 'RA RU Marking an account \'Not applicable\' will move the account to the \'Not applicable\' tab. Accounts should be marked \'Not applicable\' if they are not applicable to the group audit.',
            actionLabel: labels.notApplicableTab
        },
        notApplicable: {
            actionColumnName: labels.action,
            titleTip: 'RA RU Selecting \'Unrelate\' will move the account to the \'Not related\' tab. Accounts that are \'Not related\' should either be related to a Primary team account or be marked \'Not applicable\' if they are not applicable to the group audit.',
            actionLabel: labels.unrelate
        }
    },
    nextComponent: labels.nextComponent,
    prevComponent: labels.prevComponent
}

export const unmappedRisksTableColumnLabels = {
    riskName: "RA RU Component team risk",
	actions: "RA RU Action"
}

export const AdminUserErrors = {
    userError: "ユーザーが見つかりません。"
}

/*RBAC Errors*/
export const RbacErrors = {
    106: "このアクションを実行するために必要な権限がありません。"
};

export const Errors = {
    106: "このアクションを実行するために必要な権限がありません。",
    107: "このアクションを実行するために必要な権限がありません。",
    111: "自分に権限委譲することはできません。",
    112: "ユーザーが見つかりません。",
    310: "プロジェクトが見つかりません。",
    314: "1人以上のグループ管理者のドメインはこのグループに許可されていません。",
    316: "チームメンバーを追加するにはプロジェクトオーナーまたはグループ管理者である必要があります。アクセス権を入手するには、プロジェクトオーナーに相談してください。",
    317: "内部のメンバーのみプロジェクトオーナーに追加できます。以下は外部ユーザーです{0}。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    318: "ドメイン{0}は以下のグループに許可されていません{1}。",
    319: "このプロジェクトは別のプロジェクトオーナーが完了しました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    321: "このアクションを完了するにはプロジェクトオーナーである必要があります。アクセス権を入手するには、プロジェクトオーナーに相談してください。",
    323: "このグループは別のチームメンバーに削除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    324: "このプロジェクトを完了するにはプロジェクトオーナーである必要があります。エラーが続く場合は、ヘルプデスクに連絡してください。",
    325: "これらの変更を行うにはプロジェクトオーナーまたはグループ管理者である必要があります。アクセス権を入手するには、プロジェクトオーナーに相談してください。",
    326: "このプロジェクトを保存するには全ての必須フィールドに入力します。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    327: "プロジェクトは既に保存されています。",
    328: "追加しようとしているチームメンバーは、すでにこのグループのメンバーです。ページを更新し再試行してください。",
    330: "最新のプロジェクトオーナーは削除できません",
    331: "1つ以上のグループが別のチームメンバーによって削除されました。ページを更新して再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    332: "少なくても1人のプロジェクトオーナーが必要です。このプロジェクトからあなた自身を削除することはできません。",
    341: "選択したクライアントまたはエンゲージメントにアクセスできません。",
    343: "アクティブなプロジェクトおよびドラフトプロジェクトのみ削除できます。ページを更新して再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    344: "プロジェクト―オーナーでなければこのプロジェクトを削除できません。ページを更新して再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    345: "このプロジェクトは他のチームメンバーによって削除されました。ページを更新し再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",
    346: "別のプロジェクトオーナー又はエンティティ管理者が既に｛0｝へのアクセス権を確認しています。アクセスログを更新し再試行してください。",
    347: "このプロジェクトにおいて連絡先を追加、リムーブするためにはプロジェクトオーナーもしくはエンティティ管理者である必要があります。プロジェクトオーナーにアクセス権について連絡してください。",
    348: "管理者であるエンティティからのみ連絡先をリムーブできます。以下の連絡先はあなたが管理者でないエンティティに属しているためリムーブできません。",
    360: "この操作を完了するにはこのプロジェクトのプロジェクトオーナーである必要があります。",
    361: "この操作を行うにはプロジェクトオーナーもしくはエンティティ管理者である必要があります。プロジェクトオーナーにアクセス権のリクエストを行ってください。",
    362: "あなたが管理者であるエンティティに属する連絡先へのアクセス権のみ管理が可能です。以下の連絡先はあなたが管理者ではないエンティティに属しているため、アクセス権の編集はできません: {0}。",
    364: "このプロジェクトから削除された一つ以上の連絡先へのアクセス権を編集しようとしています。ページを更新し再試行してください。",
    365: "このプロジェクトから削除された一つ以上の連絡先の属性を編集しようとしています： {0} ページを更新し再試行してください。",
    366: "あなたが管理者であるエンティティに属する連絡先への属性のみ編集することができます。以下の連絡先はあなたが管理者ではないエンティティに属しています： {0}",
    367: "編集中のカスタム列は、他のチーム メンバーによって削除されました。ページを更新し再試行してください。",
    368: "編集中のカスタム列オプションは、他のチーム メンバーによって削除されました。ページを更新し再試行してください。",
    369: "このアクションを実行するにはプロジェクトオーナーである必要があります。",
    370: "あなたが管理者であるエンティティに属する連絡先の属性のみ編集できます。以下の連絡先はあなたが管理者ではないエンティティに属しています: {0}",
    372: "この操作を実施するにはプロジェクトオーナーである必要があります。",
    373: "連絡先リストの画面ではプロジェクトオーナーを削除できません。プロジェクトウィザードに進んでリクエストされた操作を実行してください。",
    374: "RA RU You cannot remove yourself as Project Owner from this project.",
	375: "RA RU You cannot remove the last Project Owner from a project. At least 1 Project Owner must remain.",
	376: "RA RU You must be a Project owner to add/remove a Project owner or an Entity administrator from the project. The following contacts cannot be removed: {0}",
    378: "RA RU Domain cannot be removed as it is in use by a contact on the Contact list page of this Oversight project. Go to the Contact list page and remove contact(s) with this domain, then return here to remove domain.",
    502: "エンゲージメント取得の呼び出しに失敗しました。ページを更新して、再試行してください。エラーが継続する場合はヘルプデスクにご連絡ください。",
    503: "選択したクライアントにアクセスできません。",
    601: "クライアントの取得の呼び出しに失敗しました。ページを更新して、再試行してください。エラーが継続する場合はヘルプデスクにご連絡ください。",
    1605:"RA RU The selected user already exists.",

    1803: "無効なプロジェクトデータでタグ操作を実行しました。ページを更新し再試行してください。問題が続く場合は、ヘルプデスクに連絡してください。",
    1804: "このプロジェクトでこのタグ操作を実行するには、プロジェクトオーナーである必要があります。",
    1901: "メッセージ送信APIコールに失敗しました",
    1902: "メッセージは空欄にできません",
    1903: "メッセージの長さは200文字までです",
    1904: "返信の文字の長さは50文字までです",
    1905: "返信のURIの長さは50文字までです",
    1906: "1つ以上のフィルタを選択すると続けることができます",
    1907: "受信者を繰り返すことはできません",
    1908: "エンゲージメントは空欄にできません",
    1909: "メッセージタイプが有効な値ではありません",
    1910: "受信者は空欄にできません",
    1911: "通知メッセージは空欄にできません",
    1912: "受信者タイプが有効な値ではありません",
    1913: "通知を送信するための適切なアクセスがありません。プロジェクトオーナーかエンティティ管理者にアクセスのリクエストを相談してください。",
    1914: "通知は内部の連絡先のみに送信できます。メッセージ受信者をレビューし、外部連絡先を削除して続けて下さい。",
    2101: "現在EYポリシーの作成、承認、通知サービスは利用できません。関連するすべてのポリシーが完了したかどうかを確認できません。関連ポリシーのレビューが未了の場合は、ページを更新して再試行してください。エラーが続く場合は、ヘルプデスクに連絡してください。",

    	// Reconciliation 
	2701: 'Ra RU Get All Reconciliations call failed.',
	2702: 'Ra RU Invalid request.',
	2703: 'Ra RU Get by Id Reconciliations call failed.',
	2704: 'Ra RU Get by Id Risks call failed.',
	2705: 'Ra RU Project not found in database.',
	2706: 'Ra RU Account not found in database.',
	2707: 'Ra RU Engagement not found in database.',
	2708: 'Ra RU Create comment call failed.',
	2709: 'Ra RU Comment has already been created. Refresh the page and try again.',
	2710: 'Ra RU Patch group component account call failed.',
	2711: 'Ra RU Group component account not found in database.',
	2712: 'Ra RU Rationale comment cannot be empty.',
	2713: 'Ra RU Rationale comment cannot have more than 4000 characters.',
	2714: 'Ra RU Group component risk was not found.',
	2715: 'Ra RU Group component was not found.',
    2718: 'Ra RU Update Reconciliation call failed.',
    2720: 'Ra RU This item has been edited or deleted by another user. Please refresh and try again.',
	2721: 'Ra RU Comment has already been created. Refresh the page and try again.'
};

export const clientValidationErrors = {
    ErrorAtleastOneEngagementAssociationRequired: "続行するには、少なくとも1つのエンゲージメントを組織図に接続してください。",
    ErrorAtleastOneGroupAssociationRequired: "続行するには、少なくとも1つのグループを組織図に接続してください。",
    ErrorStep2DataNotComplete: "続行するには、組織図の各エンティティの名前を入力してください。"
};

export const engagementsViewBy = [{
        id: 0,
        label: "全て",
        value: "全て"
    },
    {
        id: 1,
        label: "国別",
        value: "国",
        groupAttributeName: 'countryName'
    },
    {
        id: 2,
		label: "プライマリーオフィス",
        value: "地域別",
        groupAttributeName: 'regionName'
    },
    {
        id: 3,
        label: "エンゲージメントタイプ別",
        value: "タイプ",
        groupAttributeName: 'profileNature'
    }
];

export const milestones = [{
        id: 1,
        label: "スコープ",
        auditPhaseId: 1,
        value: 1
    },
    {
        id: 2,
        label: "戦略",
        auditPhaseId: 1,
        value: 2
    },
    {
        id: 3,
        label: "ウォークスルー",
        auditPhaseId: 2,
        value: 3
    },
    {
        id: 4,
        label: "期中統制テスト",
        auditPhaseId: 2,
        value: 4
    },
    {
        id: 5,
        label: "期中実証テスト",
        auditPhaseId: 2,
        value: 5
    },
    {
        id: 6,
        label: "ウォークスルー (期末プロセス)",
        auditPhaseId: 2,
        value: 6
    },
    {
        id: 7,
        label: "期末統制テスト",
        auditPhaseId: 2,
        value: 7
    },
    {
        id: 8,
        label: "期末実証テスト",
        auditPhaseId: 2,
        value: 8
    },
    {
        id: 9,
        label: "総括",
        auditPhaseId: 3,
        value: 9
    },
    {
        id: 10,
        label: "該当なし",
        auditPhaseId: 2,
        value: 10
    },
    {
        id: 11,
        label: "実施",
        auditPhaseId: 2,
        value: 11
    },
    {
        id: 12,
		label: "RA RU Scope and strategy project management",
        auditPhaseId: 1,
        value: 12
    },
    {
        id: 13,
        label: "その他のスコープ及び戦略",
        auditPhaseId: 1,
        value: 13
    },
    {
        id: 14,
        label: "CRA",
        auditPhaseId: 1,
        value: 14
    },
    {
        id: 15,
        label: "リスク評価及び重要性",
        auditPhaseId: 1,
        value: 15
    },
    {
        id: 16,
        label: "スコープ及び戦略の最終化",
        auditPhaseId: 1,
        value: 16
    },
    {
        id: 17,
        label: "ポスト-インテリム プロジェクトマネジメント",
        auditPhaseId: 2,
        value: 17
    }
];

export const daysOptions = [{
        id: daySelection.tomorrow,
        value: daySelection.tomorrow,
        label: "明日"
    },
    {
        id: daySelection.next3days,
        value: daySelection.next3days,
        label: "次の3日間"
    },
    {
        id: daySelection.next5days,
        value: daySelection.next5days,
        label: "次の5日間"
    },
    {
        id: daySelection.next10days,
        value: daySelection.next10days,
        label: "次の10日間"
    },
    {
        id: daySelection.next30days,
        value: daySelection.next30days,
        label: "次の30日間"
    }
];

export const auditPhases = [{
        id: 1,
        label: "スコープ及び戦略"
    },
    {
        id: 2,
        label: "実施"
    },
    {
        id: 3,
        label: "総括"
    }
];

export const findings = [{
        id: 1,
        label: "虚偽表示",
        subTitle: "タイプ別虚偽表示"
    },
    {
        id: 2,
        label: "不備",
        subTitle: "重要度別不備"
    }
];
export const risks = [{
    id: 1,
    label: '',
    subTitle: "タイプ別"
}];

export const auditStrategies = [{
        id: 1,
        label: "実証",
        subTitle: "タイプ別実証手続"
    },
    {
        id: 2,
        label: "統制",
        subTitle: "テスト戦略別統制"
    },
    {
        id: 3,
        label: "IT",
        subTitle: "テスト戦略によるIT手続"
    }
];

export const auditInsights = [{
        id: 1,
        label: "グループロール別"
    },
    {
        id: 2,
        label: "すべて"
    }
];

export const projectStatus = {
    Active: "アクティブ",
    Draft: "ドラフト",
    Cancel: "キャンセル",
    Complete: "完了",
    Delete: "削除"
};

export const ProjectStatusLabels = [{
        label: "初回",
        id: 1,
        value: 'Initial'
    },
    {
        label: "ドラフト",
        id: 2,
        value: 'Draft'
    },
    {
        label: "アクティブ",
        id: 3,
        value: 'Active'
    },
    {
        label: "キャンセル済",
        id: 4,
        value: 'Cancelled'
    },
    {
        label: "完了",
        id: 5,
        value: 'Completed'
    },
    {
        label: "削除済",
        id: 6,
        value: 'Delete'
    }
]

export const projectTeamEngagementTableGroup = [{
        id: 1,
        label: "作成者の割当て"
    },
    {
        id: 2,
        label: "査閲者の割当て"
    }
];

export const archiveReportQualifiedType = [{
        id: archiveReportQualifiedTypeId.notSelected,
        label: "未選択"
    },
    {
        id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
        label: "無限定適正意見 - 強調事項あり"
    },
    {
        id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
        label: "無限定適正意見 - 強調事項なし"
    },
    {
        id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
        label: "限定付適正意見 - 強調事項あり"
    },
    {
        id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
        label: "限定付適正意見 - 強調事項なし"
    },
    {
        id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
        label: "不適正意見 - 強調事項あり"
    },
    {
        id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
        label: "不適正意見 - 強調事項なし"
    },
    {
        id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
        label: "意見不表明 - 強調事項あり"
    },
    {
        id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
        label: "意見不表明 - 強調事項なし"
    }
];

export const strategyTableGroup = [{
    id: 1,
    label: ''
}];

export const roleForMember = [{
        id: roles.partnerInCharge,
        label: "筆頭業務執行社員",
        roleAbbreviation: "PTR IN CHG"
    },
    {
        id: roles.engagementPartner,
        label: "業務執行社員",
        roleAbbreviation: "EP"
    },
    {
        id: roles.executiveDirector,
        label: "エグゼクティブディレクター",
        roleAbbreviation: "EXEC DIR"
    },
    {
        id: roles.principal,
        label: "プリンシパル",
        roleAbbreviation: "PRINCIPAL"
    },
    {
        id: roles.seniorManager,
        label: "シニアマネージャー",
        roleAbbreviation: "SR.MANAGER"
    },
    {
        id: roles.manager,
        label: "マネージャー",
        roleAbbreviation: "MANAGER"
    },
    {
        id: roles.senior,
        label: "シニア",
        roleAbbreviation: "SENIOR"
    },
    {
        id: roles.staff,
        label: "スタッフ",
        roleAbbreviation: "STAFF"
    },
    {
        id: roles.intern,
        label: "Intrn",
        roleAbbreviation: "インターン"
    },
    {
        id: roles.engagementQualityReviewer,
        label: "独立審査担当社員",
        roleAbbreviation: "EQR"
    },
    {
        id: roles.otherPartner,
        label: "他のパートナー",
        roleAbbreviation: "OTHER PTR"
    },
    {
        id: roles.gdsStaff,
        label: "GDS - スタッフ",
        roleAbbreviation: "GDS-STAFF"
    },
    {
        id: roles.advisory,
        label: "アドバイザリー (ITRA、TAS、Human Capital又はその他)",
        roleAbbreviation: "ADV"
    },
    {
        id: roles.tax,
        label: "Tax",
        roleAbbreviation: "Tax"
    },
    {
        id: roles.executiveSupportServices,
        label: "エグゼクティブサポートサービス",
        roleAbbreviation: "ESS"
    },
    {
        id: roles.generalCounsel,
        label: "General Counsel",
        roleAbbreviation: "GCO"
    },
    {
        id: roles.auditQualityReviewer,
        label: "監査品質レビューアー",
        roleAbbreviation: "AQR"
    },
    {
        id: roles.mlComponentTeam,
        label: "ML構成単位チーム",
        roleAbbreviation: "MCT"
    },
    {
        id: roles.clientSupervisor,
        label: "クライアントスーパーバイザー",
        roleAbbreviation: "ClntS"
    },
    {
        id: roles.clientStaff,
        label: "クライアントスタッフ",
        roleAbbreviation: "ClntSt"
    },
    {
        id: roles.internalAuditSupervisor,
        label: "内部監査スーパーバイザー",
        roleAbbreviation: "IASup"
    },
    {
        id: roles.internalAuditStaff,
        label: "内部監査スタッフ",
        roleAbbreviation: "IASt"
    },
    {
        id: roles.regulator,
        label: "規制当局",
        roleAbbreviation: "Reglr"
    },
    {
        id: roles.other,
        label: "その他 (例: デューディリジェンス レビュー)",
        roleAbbreviation: "Otrs"
    },
    {
        id: roles.office,
        label: "オフィス",
        roleAbbreviation: "Off"
    },
    {
        id: roles.area,
        label: "エリア",
        roleAbbreviation: "Area"
    },
    {
        id: roles.industry,
        label: "業種",
        roleAbbreviation: "IND"
    },
    {
        id: roles.national,
        label: "国籍",
        roleAbbreviation: "NAT"
    },
    {
        id: roles.global,
        label: "グローバル",
        roleAbbreviation: "GBL"
    },
    {
        id: roles.gsdSenior,
        label: "GDS - シニア",
        roleAbbreviation: "GDS-SENIOR"
    },
    {
        id: roles.gsdManager,
        label: "GDS - マネージャー",
        roleAbbreviation: "GDS-MANAGER"
    }
];

export const toggleCCPEntityOptions = [{
        id: toggleCCPEntityDetail.comingDue,
        label: labels.comingDue
    },
    {
        id: toggleCCPEntityDetail.overdue,
        label: labels.taskStatusOverdue
    },
    {
        id: toggleCCPEntityDetail.returned,
        label: labels.returned
    }
];


export const reportReadinessSeries = [{
        id: readinessReportCategories.comingDueOver2Weeks,
        label: `> 2{break}${labels.weeks}`
    },
    {
        id: readinessReportCategories.comingDue12Weeks,
        label: `1-2{break}${labels.weeks}`
    },
    {
        id: readinessReportCategories.comingDueUnder1Week,
        label: `< 1{break}${labels.week}`
    },
    {
        id: readinessReportCategories.overDueUnder1Week,
        label: `< 1{break}${labels.week}`
    },
    {
        id: readinessReportCategories.overDue12Weeks,
        label: `1-2{break}${labels.weeks}`
    },
    {
        id: readinessReportCategories.overDueOver2Weeks,
        label: `> 2{break}${labels.weeks}`
    }
];

export const natureOfEngagementsLabels = {
    [natureOfEngagements.auditStatements.id]: "財務諸表監査",
    [natureOfEngagements.integratedStatements.id]: "統合監査（財務諸表監査及び財務報告に係る内部統制の監査）",
    [natureOfEngagements.reviewStatements.id]: "期中財務諸表のレビュー",
    [natureOfEngagements.nonAuditAccount.id]: "非監査業務‐勘定科目/アサーション/SCOTに関する機能を利用する",
    [natureOfEngagements.nonAuditWorkPlan.id]: "非監査業務‐作業計画に関する機能のみを利用する"
}

export const AdminRoles = [{
        label: "アプリケーション管理者リーダー",
        id: 1
    },
    {
        label: "アプリケーション管理者ライター",
        id: 2
    },
    {
        label: "アプリケーション特別管理者",
        id: 3
    }
]

export const userType = [{
        value: 1,
        label: "内部"
    },
    {
        value: 2,
        label: "外部"
    }
];

export const MessageType = [{
        value: 1,
        label: "Eメール"
    },
    {
        value: 2,
        label: "通知"
    }
];

export const groupRole = [{
        value: 1,
        label: "プライマリーチーム",
        id: 1,
        selected: false,
        disabled: false
    },
    {
        value: 2,
        label: "リージョナルチーム",
        id: 2,
        selected: false,
        disabled: false
    }, {
        value: 3,
        label: "構成単位チーム",
        id: 3,
        selected: false,
        disabled: false
    },
    {
        value: 4,
        label: "EY以外の監査人に報告する構成単位チーム",
        id: 4,
        selected: false,
        disabled: false
    },
    {
        value: 5,
        label: "該当なし",
        id: 5,
        selected: false,
        disabled: false
    }
];

export const accessLogResource = [{
        id: 1,
        label: "追加する連絡先"
    },
    {
        id: 2,
        label: "リムーブする連絡先"
    }
]

export const addContactsTabsResource = [{
        id: 1,
        label: "アクセス"
    },
    {
        id: 2,
        label: "属性"
    },
    {
        id: 3,
        label: "タグ"
    }
]

export const tags = [{
        name: "監査パートナー",
        id: 'auditPartner'
    },
    {
        name: "監査エンゲージメントマネージャー",
        id: 'auditEngagementManager'
    }, {
        name: "GDSエンゲージメントマネージャー",
        id: 'gdsEngagementManager'
    }, {
        name: "TAXパートナー",
        id: 'taxPartner'
    }, {
        name: "TAXエンゲージメントマネージャー",
        id: 'taxEngagementManager'
    }, {
        name: "FAITパートナー",
        id: 'faitPartner'
    }, {
        name: "FAITエンゲージメントマネージャー",
        id: 'faitEngagementManager'
    }, {
        name: "アドバイザリーパートナー",
        id: 'advisoryPartner'
    }, {
        name: "アドバイザリーエンゲージメントマネージャー",
        id: 'advisoryEngagementManager'
    }, {
        name: "専門家",
        id: 'specialist'
    }, {
        name: "クライアント管理者",
        id: 'clientadministrator'
    }
];

export const dashboardContactViews = [{
        id: dashboardTabId.milestones,
        value: dashboardViewsConstants.milestones,
        tooltipText: "マイルストーン別の監査の進捗",
        key: "マイルストーン",
        checked: false,
    },
    {
        id: dashboardTabId.projectManagement,
        value: dashboardViewsConstants.projectManagement,
        tooltipText: "レビューノート及び割当てのステータス(期限超過のアイテムを含む)。外部ユーザーには、プロジェクト管理ダッシュボードへのアクセス権を付与できません。",
		key: "プロジェクトマネジメント",
        checked: false,
    },
    {
        id: dashboardTabId.groupAudit,
        value: dashboardViewsConstants.groupAudit,
        tooltipText: "プライマリーチームと構成単位チームのステータス(差戻し済みや期限超過のアイテムを含む)。",
        key: "グループ監査",
        checked: false,
    },
    {
        id: dashboardTabId.groupRiskAssessment,
        value: dashboardViewsConstants.groupRiskAssessment,
        tooltipText: "プライマリーチームと構成単位チームのグループリスク評価ビュー。このビューはクライアントに表示されません。",
        key: "グループリスク評価",
        checked: false,
    },
    {
        id: dashboardTabId.canvasClientPortal,
        value: dashboardViewsConstants.ccp,
        tooltipText: "リクエストのステータス（期限間近、期限超過および差戻し済のアイテムを含む）",
        key: "EY Canvas Client Portal",
        checked: false,
    },
    {
        id: dashboardTabId.insights,
        value: dashboardViewsConstants.insights,
        tooltipText: "プライマリーチームと構成単位チーム間のリスク、実証手続、統制戦略及び発見事項の比較。外部ユーザーには、インサイトダッシュボードへのアクセス権を付与できません。",
        key: "インサイト",
        checked: false,
    },
    {
        id: dashboardTabId.reporting,
        value: dashboardViewsConstants.reporting,
        tooltipText: "意見表明に向けた準備状況、発見事項及びタスク完了ステータスを国別に報告",
        key: "レポーティング",
        checked: false,
    }
]

export const colorOptionsLabels = {
    red: "赤",
    orange: "オレンジ",
    teal: "青緑",
    blue: "青",
    purple: "紫",
    green: "緑",
    yellow: "黄",
    gray: "グレー"
};

export const exportToExcelLabels = {
    yes: "はい",
    no: "いいえ",
    exportData: labels.exportData,
    exportButtonTitle: "このEY Oversightプロジェクトの左側のレールにある組織図で選択されたエンティティの詳細なクライアントリクエスト情報をダウンロードするには、ここをクリックしてください。",
    projectInfo: "プロジェクト情報",
    exportDate: "エクスポート日付",
    engagementName: labels.engagementNameLabel,
    engagementId: labels.engagementId,
    requestItemNumber: "リクエストアイテム番号",
    requestTitle: "リクエストタイトル",
    priority: "優先度",
    status: labels.status,
    receivedDate: "受領日",
    dueDate: "期日",
    overdue: labels.overdueLabel,
    eyContact: "EY担当者",
    assignedTo: "割当先",
    statusLabels: [{
            id: 1,
            label: "ドラフト"
        },
        {
            id: 2,
            label: "クライアント担当者がありません"
        },
        {
            id: 3,
            label: "送信済"
        },
        {
            id: 4,
            label: "システムエラー"
        },
        {
            id: 5,
            label: "無効なクライアントの連絡先"
        },
        {
            id: 6,
            label: "回答未了"
        },
        {
            id: 7,
            label: "受領済"
        },
        {
            id: 8,
            label: "承諾済"
        },
        {
            id: 9,
            label: "返却済"
        },
        {
            id: 10,
            label: "引き戻し済"
        },
        {
            id: 11,
            label: "送信中"
        },
        {
            id: 12,
            label: "承認中"
        },
        {
            id: 13,
            label: "引き戻し中"
        },
        {
            id: 14,
            label: "削除中"
        },
        {
            id: 15,
            label: "返却中"
        },
        {
            id: 16,
            label: "回答中"
        },
        {
            id: 17,
            label: "削除済"
        },
        {
            id: 18,
            label: "無効なクライアントの連絡先が差し戻されました"
        },
        {
            id: 19,
            label: "転送中の引戻し"
        },
        {
            id: 20,
            label: "引戻済"
        },
        {
            id: 21,
            label: "完了処理中"
        },
        {
            id: 22,
            label: "転送中の引戻し"
        }
    ],
    priorityTypeLabels: [{
        id: 1,
        label: "低"
		},
		{
        id: 2,
        label: "中"
		},
		{
        id: 3,
        label: "高"
		},
		{
        id: 4,
        label: "クリティカル"
		}
	],

    risks: {
        exportButtonTitle: 'RA RU Click here to download detailed Risk assessment data for the entities selected in the organization chart in the left-hand rail of this EY Oversight project.',
        tabTitle: 'RA RU Risk assessment details',
        columns: {
            engagementName: labels.engagementNameLabel,
            engagementId: labels.engagementId,
            accountName: 'RA RU Account / disclosure name',
            pspIndex: 'RA RU PSP Index',
            accountType: 'RA RU Designation',
            assertion: 'RA RU Assertion',
            inherentRisk: 'RA RU Inherent risk',
            controlRisk: 'RA RU Control risk',
            craValue: 'RA RU Control risk assessment',
            riskType: 'RA RU Risk type',
            riskName: 'RA RU Risk name',
            relatedTasks: 'RA RU Related tasks',
            taskStatus: 'RA RU Task status',
        }
    },
    exportButtonTooltip:'RU RA Нажмите здесь, чтобы скачать подробные данные сверки для основной команды и связанной команды компонентов.',
    primaryTeamEngagementName: 'RA RU Название основного взаимодействия команды',
    componentTeamEngagementName: 'RA RU Название взаимодействия команды компонента',
    howToUseThisExport: 'RA RU Как использовать этот экспорт:',
    howToUseThisExportText: 'RA RU TBD - How to use this export text',
    reconciliationComponentExportTabTitle: 'RA RU Счета',
    reconciliationComponentExport: {
        status: 'RA RU Статус',
        primaryTeamAccountName: 'RA RU Название учетной записи основной команды',
        componentTeamAccountNames: 'RA RU Название учетной записи команды компонента(ов)',
        pspIndexes: 'RA RU Индексы PSP',
        designation: 'RA RU Обозначение',
        c: 'C',
        eo: 'E/O',
        mv: 'M/V',
        ro: 'R&O',
        pd: 'P&D',
        comment: 'RA RU Комментарий'
    },
    groupRiskStatusLabels : {
        [groupRiskStatus.open]: "RA RU Oткрыто",
        [groupRiskStatus.assessed]: "RA RU Oценено",
        [groupRiskStatus.mapped]: "RA RU Cопоставлено",
        [groupRiskStatus.unmapped]: "RA RU Hе сопоставлено",
        [groupRiskStatus.notApplicable]: "RA RU Hе применимо"
    },
    reconciliationExportTabRisks: 'RU - Риски',
	reconciliationExport: {
		status: 'RU - Статус',
		primaryTeamRiskName: 'RU - Название основного риска команды',
		componentTeamRiskName: 'RU - Название(я) риска команды компонента',
		riskDesignation: 'RU - Обозначение риска',
		accountsRelatedToRisk: 'RU - Счет(а), связанный(ые) с риском',
		c: 'C',
		eo: 'E/O',
		mv: 'M/V',
		ro: 'R&O',
		pd: 'P&D',
		comment: 'RU - Комментарий'
	}
}

export const accountDesignationsLabels = {
    [accountDesignations.significantAccount]: 'RA RU Significant',
    [accountDesignations.limitedRiskAccount]: 'RA RU Limited risk',
    [accountDesignations.insignificantAccount]: 'RA RU Insignificant',
    [accountDesignations.otherAccount]: 'RA RU Other',
    [accountDesignations.significantDisclosure]: 'RA RU Significant disclosure'
}

export const riskDesignationsLabels = {
    [riskTypeIds.significant]: 'RU - Значительный Риск',
    [riskTypeIds.fraud]: 'RU - Мошенничество Риск',
    [riskTypeIds.insignificant]: 'RU - Незначительный Риск'
};
